// // import { useEffect, useState } from "react";
// // import {
// //   Box,
// //   Paper,
// //   Stepper,
// //   Step,
// //   StepLabel,
// //   Button,
// //   Typography,
// //   MenuItem,
// //   TextField,
// //   Grid,
// //   CircularProgress,
// // } from "@mui/material";
// // import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutlined";
// // import { toast } from "react-toastify";
// // import PageHeader from "../../../components/PageHeader/PageHeader";
// // import DataTable from "../../../components/DataTable/DataTable";
// // import usePayrollEntity from "../../../utils/usePayrollEntity";
// // import { fmtRs, fmtMoney } from "../../../utils/payrollFormat";
// // import { useDispatch } from "react-redux";
// // import {
// //   calculatePayroll,
// //   getPayrollPreview,
// //   getPayrollBatchEmployees,
// //   validatePayrollBatch,
// // } from "../../../action/Payroll";
// // import { getLoggedInServiceNo } from "../../../utils/masterDataUtils";
// // import PayrollBreakdownDialog from "../../../components/PayRoll/PayrollBreakdownDialog";

// // const PRIMARY = "#1B5C20";

// // const STEPS = [
// //   { label: "Generate Payroll", description: "Select the payroll period and employee batch to run." },
// //   // { label: "Payroll Calculation", description: "Calculate earnings, deductions, EPF/ETF and PAYE for every employee in the batch." },
// //   // { label: "Payroll Validation", description: "Validate the run against configured rules and flag exceptions." },
// //   // { label: "Payroll Recalculation", description: "Recalculate after resolving any exceptions found during validation." },
// //   { label: "Payroll Preview", description: "Preview the final payroll run before sending it for approval." },
// // ];

// // const PayrollProcessing = () => {
// //   const [activeStep, setActiveStep] = useState(0);
// //   const [running, setRunning] = useState(false);

// //   const [selectedPeriod, setSelectedPeriod] = useState("");
// //   const [selectedBatch, setSelectedBatch] = useState("");

// //   const [preview, setPreview] = useState([]);
// //   const [previewLoading, setPreviewLoading] = useState(false);

// //   const [breakdownOpen, setBreakdownOpen] = useState(false);
// //   const [selectedPayroll, setSelectedPayroll] = useState(null);

// //   // Employees pulled from PayRollBatch/GetPayRollEmpBybatchId for the
// //   // batch chosen in Step 1 — this is the "service numbers from the
// //   // project's own Get API" that the Validation/Recalculation/Preview
// //   // steps run against, instead of anyone typing service numbers by hand.
// //   const [batchEmployees, setBatchEmployees] = useState([]);
// //   const [batchEmployeesLoading, setBatchEmployeesLoading] = useState(false);

// //   // const [validation, setValidation] = useState([]);
// //   // const [validationLoading, setValidationLoading] = useState(false);

// //   const dispatch = useDispatch();

// //   // const { list: preview, loading } = usePayrollEntity("payrollPreview");
// //   const { list: periods } = usePayrollEntity("payrollPeriods");
// //   const { list: batches } = usePayrollEntity("batchManagement");

// //   // Load the selected batch's active employees (service numbers) as soon
// //   // as a batch is picked, so later steps have them ready to call
// //   // PayRollCal/GetPayrollDetailsBySno and Preview/GetPreviewPayroll with.
// //   useEffect(() => {
// //     if (!selectedBatch) {
// //       setBatchEmployees([]);
// //       // setValidation([]);
// //       return;
// //     }

// //     let cancelled = false;
// //     setBatchEmployeesLoading(true);

// //     dispatch(getPayrollBatchEmployees(selectedBatch))
// //       .then((list) => {
// //         if (!cancelled) setBatchEmployees(list);
// //       })
// //       .catch((error) => {
// //         console.error("Failed to load batch employees: ", error);
// //         if (!cancelled) setBatchEmployees([]);
// //       })
// //       .finally(() => {
// //         if (!cancelled) setBatchEmployeesLoading(false);
// //       });

// //     return () => {
// //       cancelled = true;
// //     };
// //   }, [selectedBatch, dispatch]);

// //   useEffect(() => {
// //     if (activeStep !== STEPS.length - 1) {
// //       return;
// //     }

// //     if (!selectedPeriod) return;

// //     const loadPreview = async () => {
// //       setPreviewLoading(true);

// //       try {
// //         const result = await dispatch(
// //           getPayrollPreview(selectedPeriod, batchEmployees)
// //         );

// //         setPreview(result || []);

// //         if (!result || result.length === 0) {
// //           toast.info(
// //             "No employees with salary were found for the selected payroll period."
// //           );
// //         }
// //       } catch (error) {
// //         console.error("Payroll preview error: ", error);

// //         setPreview([]);

// //         toast.error(
// //           error?.message || "Failed to load payroll preview."
// //         );
// //       } finally {
// //         setPreviewLoading(false);
// //       }
// //     }

// //     loadPreview();
// //   }, [activeStep, selectedPeriod, batchEmployees, dispatch]);

// //   const filteredBatches = selectedPeriod 
// //     ? batches.filter(
// //         (batch) => String(batch.periodId) === String(selectedPeriod)
// //       )
// //     : batches;

// //   // const isCalculationStep = activeStep === 1;
// //   // const isValidationStep = activeStep === 2;
// //   // const isRecalculationStep = activeStep === 3;

// //   // const runStep = async () => {
// //   //   if (activeStep === 0) {
// //   //     if (!selectedPeriod) {
// //   //       toast.warning("Please select a payroll period");
// //   //       return;
// //   //     }
// //   //   }

// //   //   if ((isValidationStep || isRecalculationStep) && batchEmployees.length === 0) {
// //   //     toast.warning(
// //   //       "Please select a payroll batch with active employees in Step 1 first."
// //   //     );
// //   //     return;
// //   //   }

// //   //   setRunning(true);

// //   //   try {
// //   //     if (isCalculationStep) {
// //   //       // Runs PayrollCal/CalPayRoll for the whole selected period.
// //   //       await dispatch(calculatePayroll(selectedPeriod, getLoggedInServiceNo()));
// //   //     } else if (isValidationStep || isRecalculationStep) {
// //   //       if (isRecalculationStep) {
// //   //         // Recalculation: re-run the calculation, then re-check every
// //   //         // batch employee's record so exceptions found during
// //   //         // Validation get picked up again.
// //   //         await dispatch(calculatePayroll(selectedPeriod, getLoggedInServiceNo()));
// //   //       }

// //   //       setValidationLoading(true);

// //   //       const results = await dispatch(
// //   //         validatePayrollBatch(selectedPeriod, batchEmployees)
// //   //       );

// //   //       setValidation(results);
// //   //       setValidationLoading(false);

// //   //       const exceptions = results.filter((r) => r.status === "Exception").length;

// //   //       if (exceptions > 0) {
// //   //         toast.warning(
// //   //           `${exceptions} of ${results.length} employee(s) still need attention.`,
// //   //           { autoClose: 2500 }
// //   //         );
// //   //       }
// //   //     } else {
// //   //       // Step 1 (Generate Payroll) has nothing to call yet — the period
// //   //       // and batch are just being selected.
// //   //       await new Promise((resolve) => setTimeout(resolve, 400));
// //   //     }

// //   //     toast.success(`${STEPS[activeStep].label} completed.`, { autoClose: 1800 });
// //   //     setActiveStep((s) => Math.min(s + 1, STEPS.length - 1));
// //   //   } catch (error) {
// //   //     console.error(`${STEPS[activeStep].label} failed: `, error);

// //   //     toast.error(
// //   //       error?.response?.data?.message || error?.response?.data?.Message ||
// //   //       error?.message || `Failed to run ${STEPS[activeStep].label}.`
// //   //     );
// //   //   } finally {
// //   //     setValidationLoading(false);
// //   //     setRunning(false);
// //   //   }
// //   // };

// //   const runStep = async () => {
// //     // Only payroll period is mandatory
// //     if (activeStep === 0) {
// //       if (!selectedPeriod) {
// //         toast.warning("Please select a payroll period");
// //         return;
// //       }
// //     }

// //     setRunning(true);

// //     try {
// //       if (activeStep < STEPS.length - 1) {
// //         // Steps 1 - 4 are navigation only. No payroll calculation logic.
// //         await new Promise((resolve) => setTimeout(resolve, 300));

// //         toast.success(
// //           `${STEPS[activeStep].label} completed.`,
// //           { autoClose: 1800 }
// //         );

// //         setActiveStep((s) => Math.min(s+1, STEPS.length - 1));
// //       }
// //     } finally {
// //       setRunning(false);
// //     }
// //   } 

// //   const isPreviewStep = activeStep === STEPS.length - 1;
// //   const totalGross = preview.reduce((s, r) => s + r.gross, 0);
// //   const totalNet = preview.reduce((s, r) => s + r.net, 0);

// //   const handleSubmitForApproval = async () => {
// //     if (!selectedPeriod) {
// //       toast.warning("Please select a payroll period.");
// //       return;
// //     }

// //     setRunning(true);

// //     try {
// //       await dispatch(calculatePayroll(selectedPeriod, getLoggedInServiceNo()));
      
// //       setPreview([]);

// //       toast.success(
// //         "Payroll generated successfully. The payroll preview has been cleared.",
// //         { autoClose: 2500 }
// //       );

// //       // Return to step 1
// //       setActiveStep(0);
// //     } catch (error) {
// //       console.error("Payroll generation error: ", error);

// //       toast.error(
// //         error?.response?.data?.message || error?.response?.data?.Message ||
// //         error?.message || "Failed to generate payroll."
// //       );
// //     } finally {
// //       setRunning(false);
// //     }
// //   }

// //   return (
// //     <Box>
// //       <PageHeader
// //         icon={<PlayCircleOutlineIcon sx={{ color: PRIMARY, fontSize: 28 }} />}
// //         title="Payroll Processing"
// //         subtitle="Generate, calculate, validate and preview a payroll run before approval."
// //       />

// //       <Paper elevation={0} sx={{ p: 3, borderRadius: 3, border: "1px solid #EAEAEA", mb: 3 }}>
// //         <Stepper
// //           activeStep={activeStep}
// //           alternativeLabel
// //           sx={{
// //             mb: 3,
// //             "& .MuiStepIcon-root.Mui-active": { color: PRIMARY },
// //             "& .MuiStepIcon-root.Mui-completed": { color: PRIMARY },
// //           }}
// //         >
// //           {STEPS.map((step) => (
// //             <Step key={step.label}>
// //               <StepLabel>{step.label}</StepLabel>
// //             </Step>
// //           ))}
// //         </Stepper>

// //         {!isPreviewStep && (
// //           <>
// //             <Typography variant="body2" color="#646464" sx={{ mb: 2 }}>
// //               {STEPS[activeStep].description}
// //             </Typography>

// //             {activeStep === 0 && (
// //               <div className="mb-4 grid max-w-[480px] grid-cols-1 gap-4 sm:grid-cols-2">
// //                 {/* Payroll Period */}
// //                 <div className="w-full">
// //                   <label
// //                     htmlFor="payroll-period"
// //                     className="mb-1 block text-sm font-medium text-gray-700"
// //                   >
// //                     Payroll Period
// //                   </label>

// //                   <select
// //                     id="payroll-period"
// //                     value={selectedPeriod}
// //                     onChange={(e) => {
// //                       setSelectedPeriod(e.target.value);
// //                       setSelectedBatch("");
// //                     }}
// //                     className="h-10 w-full rounded-md border border-gray-300 bg-white px-3 text-sm text-gray-700 outline-none transition focus:border-[#1B5C20] focus:ring-1 focus:ring-[#1B5C20]"
// //                   >
// //                     <option value="">Select Payroll Period</option>

// //                     {periods.map((period) => (
// //                       <option key={period.id} value={period.id}>
// //                         {period.code} - {period.name}
// //                       </option>
// //                     ))}
// //                   </select>
// //                 </div>

// //                 {/* Payroll Batch */}
// //                 {/* <div className="w-full">
// //                   <label
// //                     htmlFor="payroll-batch"
// //                     className="mb-1 block text-sm font-medium text-gray-700"
// //                   >
// //                     Payroll Batch
// //                   </label>

// //                   <select
// //                     id="payroll-batch"
// //                     value={selectedBatch}
// //                     onChange={(e) => {
// //                       setSelectedBatch(e.target.value);
// //                     }}
// //                     disabled={!selectedPeriod}
// //                     className="h-10 w-full rounded-md border border-gray-300 bg-white px-3 text-sm text-gray-700 outline-none transition focus:border-[#1B5C20] focus:ring-1 focus:ring-[#1B5C20] disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-400"
// //                   >
// //                     <option value="">Select Payroll Batch</option>

// //                     {filteredBatches.map((batch) => (
// //                       <option key={batch.id} value={batch.id}>
// //                         {batch.batchNo} - {batch.name}
// //                       </option>
// //                     ))}
// //                   </select>
// //                 </div> */}
// //               </div>
// //             )}

// //             {activeStep === 0 && selectedBatch && (
// //               <Typography variant="caption" color="#888" sx={{ display: "block", mb: 2 }}>
// //                 {batchEmployeesLoading
// //                   ? "Loading batch employees..."
// //                   : `${batchEmployees.length} active employee(s) in this batch.`}
// //               </Typography>
// //             )}

// //             <Button
// //               variant="contained"
// //               onClick={runStep}
// //               disabled={running}
// //               startIcon={running ? <CircularProgress size={16} sx={{ color: "#fff" }} /> : null}
// //               sx={{
// //                 backgroundColor: PRIMARY,
// //                 textTransform: "none",
// //                 borderRadius: 2,
// //                 px: 3,
// //                 "&:hover": { backgroundColor: "#145016" },
// //               }}
// //             >
// //               {running ? "Processing..." : `Run: ${STEPS[activeStep].label}`}
// //             </Button>

// //             {/* {(isValidationStep || isRecalculationStep) && validation.length > 0 && (
// //               <Box sx={{ mt: 3 }}>
// //                 <DataTable
// //                   loading={validationLoading}
// //                   rows={validation}
// //                   searchKeys={["empNo", "name"]}
// //                   searchPlaceholder="Search employees..."
// //                   pageSize={6}
// //                   columns={[
// //                     { key: "name", label: "Employee", render: (r) => `${r.name} (${r.empNo})` },
// //                     { key: "gross", label: "Gross (Rs)", align: "right", render: (r) => fmtMoney(r.gross) },
// //                     { key: "totalDeductions", label: "Deductions (Rs)", align: "right", render: (r) => fmtMoney(r.totalDeductions) },
// //                     { key: "net", label: "Net Pay (Rs)", align: "right", render: (r) => fmtMoney(r.net) },
// //                     {
// //                       key: "status",
// //                       label: "Status",
// //                       render: (r) => (
// //                         <Typography
// //                           variant="body2"
// //                           sx={{ fontWeight: 600, color: r.status === "OK" ? PRIMARY : "#C62828" }}
// //                         >
// //                           {r.status}
// //                         </Typography>
// //                       ),
// //                     },
// //                     { key: "message", label: "Details" },
// //                   ]}
// //                 />
// //               </Box>
// //             )} */}
// //           </>
// //         )}

// //         {isPreviewStep && (
// //           <>
// //             <Typography variant="body2" color="#646464" sx={{ mb: 2 }}>
// //               {STEPS[activeStep].description} Gross: <b>{fmtMoney(totalGross)}</b> &nbsp;|&nbsp; Net:{" "}
// //               <b style={{ color: PRIMARY }}>{fmtMoney(totalNet)}</b>
// //             </Typography>
// //             <DataTable
// //               loading={previewLoading}
// //               rows={preview}
// //               searchKeys={["empNo", "name"]}
// //               searchPlaceholder="Search employees..."
// //               pageSize={6}
// //               columns={[
// //                 { key: "name", label: "Employee", render: (r) => `${r.name} (${r.empNo})` },
// //                 { key: "workingDays", label: "Working Days", align: "right", render: (r) => r.workingDays },
// //                 { key: "presentDays", label: "Present", align: "right", render: (r) => r.presentDays },
// //                 { key: "gross", label: "Gross (Rs)", align: "right", render: (r) => fmtMoney(r.gross) },
// //                 { key: "totalDeductions", label: "Deductions (Rs)", align: "right", render: (r) => fmtMoney(r.totalDeductions) },
// //                 { key: "epf", label: "EPF (Rs)", align: "right", render: (r) => fmtMoney(r.epf) },
// //                 { key: "net", label: "Net Pay (Rs)", align: "right", render: (r) => fmtMoney(r.net) },

// //                 {
// //                   key: "breakdown",
// //                   label: "Breakdown",
// //                   align: "center",
// //                   render: (r) => (
// //                     <Button
// //                       size="small"
// //                       variant="outlined"
// //                       onClick={() => {
// //                         setSelectedPayroll(r);
// //                         setBreakdownOpen(true);
// //                       }}
// //                       sx={{
// //                         textTransform: "none",
// //                         borderColor: PRIMARY,
// //                         color: PRIMARY,
// //                         borderRadius: 1.5,
// //                         fontSize: "0.75rem",
// //                         "&:hover": {
// //                           borderColor: PRIMARY,
// //                           backgroundColor: "#F0F7F0",
// //                         },
// //                       }}  
// //                     >
// //                       View Breakdown
// //                     </Button>
// //                   )
// //                 }
// //               ]}
// //             />
// //             <Box sx={{ mt: 2, display: "flex", gap: 1.5 }}>
// //               <Button
// //                 variant="outlined"
// //                 onClick={() => setActiveStep(0)}
// //                 sx={{ textTransform: "none", borderColor: PRIMARY, color: PRIMARY, borderRadius: 2 }}
// //               >
// //                 Start New Run
// //               </Button>
// //               <Button
// //                 variant="contained"
// //                 onClick={handleSubmitForApproval}
// //                 disabled={running || previewLoading || preview.length === 0}
// //                 sx={{ backgroundColor: PRIMARY, textTransform: "none", borderRadius: 2, "&:hover": { backgroundColor: "#145016" } }}
// //               >
// //                 { running ? "Generating Payroll..." : "Submit for Approval" }
// //               </Button>
// //             </Box>
// //           </>
// //         )}
// //       </Paper>

// //       <PayrollBreakdownDialog 
// //         open={breakdownOpen}
// //         payroll={selectedPayroll}
// //         onClose={() => {
// //           setBreakdownOpen(false);
// //           setSelectedPayroll(null);
// //         }}
// //       />
// //     </Box>
// //   );
// // };

// // export default PayrollProcessing;


// import { useEffect, useState } from "react";
// import { useDispatch } from "react-redux";
// import {
//   CalendarDays,
//   Play,
//   RefreshCw,
//   Send,
//   Eye,
// } from "lucide-react";
// import { toast } from "react-toastify";

// import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
// import Table from "../../../components/Table/Table";

// import usePayrollEntity from "../../../utils/usePayrollEntity";
// import { fmtMoney } from "../../../utils/payrollFormat";
// import { getLoggedInServiceNo } from "../../../utils/masterDataUtils";
// import {
//   calculatePayroll,
//   getPayrollPreview,
//   getPayrollBatchEmployees,
// } from "../../../action/Payroll";

// import PayrollBreakdownDialog from "../../../components/PayRoll/PayrollBreakdownDialog";
// import Toast from "../../../components/Toast/Toast";
// import useToast from "../../../utils/useToast";
// import PayrollApprovalProgressDialog, { APPROVAL_STATUS } from "../../../components/PayRoll/PayrollApprovalProgressDialog";
// import payRollService from "../../../services/PayrollService";

// const TABLE_PROPS = {
//   search: true,
//   searchLabel: "Search",
//   pageSize: 10,
//   scrollClassName: "",
//   emptyMessage: "No payroll records found",
//   loadingMessage: "Loading...",
// };

// const PayrollProcessing = () => {
//   const dispatch = useDispatch();

//   const [running, setRunning] = useState(false);

//   const [selectedPeriod, setSelectedPeriod] = useState("");
//   const [selectedBatch, setSelectedBatch] = useState("");

//   const [preview, setPreview] = useState([]);
//   const [previewLoading, setPreviewLoading] = useState(false);

//   const [breakdownOpen, setBreakdownOpen] = useState(false);
//   const [selectedPayroll, setSelectedPayroll] = useState(null);

//   const [batchEmployees, setBatchEmployees] = useState([]);
//   const [batchEmployeesLoading, setBatchEmployeesLoading] = useState(false);

//   const [approvalDialogOpen, setApprovalDialogOpen] = useState(false);
//   const [approvalStatus, setApprovalStatus] = useState(APPROVAL_STATUS.IDLE);
//   const [approvalError, setApprovalError] = useState('');

//   const { list: periods } = usePayrollEntity("payrollPeriods");
//   const { list: batches } = usePayrollEntity("batchManagement");

//   const { toast, showToast, hideToast } = useToast();

//   /*
//    * Load employees belonging to the selected batch.
//    */
//   useEffect(() => {
//     if (!selectedBatch) {
//       setBatchEmployees([]);
//       return;
//     }

//     let cancelled = false;

//     setBatchEmployeesLoading(true);

//     dispatch(getPayrollBatchEmployees(selectedBatch))
//       .then((list) => {
//         if (!cancelled) {
//           setBatchEmployees(list || []);
//         }
//       })
//       .catch((error) => {
//         console.error("Failed to load batch employees:", error);

//         if (!cancelled) {
//           setBatchEmployees([]);
//         }
//       })
//       .finally(() => {
//         if (!cancelled) {
//           setBatchEmployeesLoading(false);
//         }
//       });

//     return () => {
//       cancelled = true;
//     };
//   }, [selectedBatch, dispatch]);

//   /*
//    * Load preview whenever a payroll period is selected and
//    * the preview is requested by the existing flow.
//    */
//   useEffect(() => {
//     if (!selectedPeriod) {
//       setPreview([]);
//       return;
//     }

//     const loadPreview = async () => {
//       setPreviewLoading(true);

//       try {
//         const result = await dispatch(
//           getPayrollPreview(selectedPeriod, batchEmployees)
//         );

//         setPreview(result || []);

//         if (!result || result.length === 0) {
//           // toast.info(
//           //   "No employees with salary were found for the selected payroll period."
//           // );

//           showToast("The selected payroll period has already been generated.", 'warning');
//         }
//       } catch (error) {
//         console.error("Payroll preview error:", error);

//         setPreview([]);

//         // toast.error(
//         //   error?.message || "Failed to load payroll preview."
//         // );

//         showToast(error?.message || "Failed to load payroll preview.", 'error');
//       } finally {
//         setPreviewLoading(false);
//       }
//     };

//     loadPreview();
//   }, [selectedPeriod, batchEmployees, dispatch]);

//   const filteredBatches = selectedPeriod
//     ? batches.filter(
//         (batch) =>
//           String(batch.periodId) === String(selectedPeriod)
//       )
//     : batches;

//   const totalGross = preview.reduce(
//     (sum, row) => sum + Number(row.gross || 0),
//     0
//   );

//   const totalNet = preview.reduce(
//     (sum, row) => sum + Number(row.net || 0),
//     0
//   );

//   const handlePeriodChange = (value) => {
//     setSelectedPeriod(value);
//     setSelectedBatch("");
//     setPreview([]);
//   };

//   const handleOpenApprovalDialog = () => {
//     if (!selectedPeriod) {
//       showToast("Please select a payroll period.", "warning");
//       return;
//     }

//     if (preview.length === 0) {
//       showToast("There are no payroll records available for approval.", "warning");
//       return;
//     }

//     setApprovalStatus(APPROVAL_STATUS.IDLE);
//     setApprovalError('');
//     setApprovalDialogOpen(true);
//   }

//   const handleExecuteSubmission = async () => {
//     setRunning(true);

//     try {
//       // 1. Calculate payroll
//       setApprovalStatus(APPROVAL_STATUS.GENERATING_PAYROLL);
//       await dispatch(
//         calculatePayroll(selectedPeriod, getLoggedInServiceNo())
//       );

//       // 2. Generate bank report transfer
//       setApprovalStatus(APPROVAL_STATUS.GENERATING_BANK_REPORT);
//       const bankResponse = await payRollService.GetBankReportDetailsByPeriodId(selectedPeriod);

//       if (bankResponse && bankResponse.StatusCode !== 200) {
//         throw new Error(bankResponse.Result || "Failed to generate bank report.");
//       }

//       // Finished successfully
//       setApprovalStatus(APPROVAL_STATUS.COMPLETED);
//       setPreview([]);
//       setSelectedPeriod("");
//       setSelectedBatch("");
//       setBatchEmployees([]);
//     } catch (error) {
//       console.error("[Payroll Processing] Submission workflow failed: ", error);
//       const msg = 
//         error?.response?.data?.message || 
//         error?.response?.data?.Message || 
//         error?.message ||
//         "Failed to complete payroll submission.";
//       setApprovalError(msg);
//       setApprovalStatus(APPROVAL_STATUS.FAILED); 
//     } finally {
//       setRunning(false);
//     }
//   }

//   const handleRefreshPreview = async () => {
//     if (!selectedPeriod) {
//       // toast.warning("Please select a payroll period.");
//       showToast("Please select a payroll period.", "warning");
//       return;
//     }

//     setPreviewLoading(true);

//     try {
//       const result = await dispatch(
//         getPayrollPreview(
//           selectedPeriod,
//           batchEmployees
//         )
//       );

//       setPreview(result || []);

//       // toast.success("Payroll preview refreshed.", {
//       //   autoClose: 1500,
//       // });
//       showToast("Payroll preview refreshed.", "success");
//     } catch (error) {
//       console.error("Payroll preview error:", error);

//       // toast.error(
//       //   error?.message || "Failed to refresh payroll preview."
//       // );

//       showToast(error?.message || "Failed to refresh payroll preview.", "error");
//     } finally {
//       setPreviewLoading(false);
//     }
//   };

//   const handleSubmitForApproval = async () => {
//     if (!selectedPeriod) {
//       // toast.warning("Please select a payroll period.");
//       showToast("Please select a payroll period.", "warning");
//       return;
//     }

//     if (preview.length === 0) {
//       // toast.warning(
//       //   "There are no payroll records available for approval."
//       // );
//       showToast("There are no payroll records available for approval.", "warning");
//       return;
//     }

//     setRunning(true);

//     try {
//       await dispatch(
//         calculatePayroll(
//           selectedPeriod,
//           getLoggedInServiceNo()
//         )
//       );

//       setPreview([]);

//       // toast.success(
//       //   "Payroll generated successfully. The payroll preview has been cleared.",
//       //   { autoClose: 2500 }
//       // );

//       showToast("Payroll generated successfully. The payroll preview has been cleared.", "success");

//       setSelectedPeriod("");
//       setSelectedBatch("");
//       setBatchEmployees([]);
//     } catch (error) {
//       console.error("Payroll generation error:", error);

//       // toast.error(
//       //   error?.response?.data?.message ||
//       //     error?.response?.data?.Message ||
//       //     error?.message ||
//       //     "Failed to generate payroll."
//       // );

//       showToast(`${error?.response?.data?.message ||
//           error?.response?.data?.Message ||
//           error?.message ||
//           "Failed to generate payroll."}`,"error")
//     } finally {
//       setRunning(false);
//     }
//   };

//   return (
//     <div className="space-y-4 p-6">
//       <Breadcrumb
//         trail={["Payroll", "Payroll Processing"]}
//         title="Payroll Processing"
//         subtitle="Generate payroll and review the final payroll results before approval."
//       />

//       {/* ─────────────────────────────────────────────────────────────
//           Payroll Generation
//       ───────────────────────────────────────────────────────────── */}
//       <div className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
//         <div className="border-b border-gray-200 px-5 py-4">
//           <div className="flex items-center gap-3">
//             <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-50 text-primary-700">
//               <CalendarDays size={18} />
//             </div>

//             <div>
//               <h2 className="text-sm font-semibold text-gray-900">
//                 Generate Payroll
//               </h2>

//               <p className="mt-0.5 text-xs text-gray-500">
//                 Select a payroll period and generate the payroll
//                 calculation.
//               </p>
//             </div>
//           </div>
//         </div>

//         <div className="px-5 py-5">
//           <div className="grid max-w-[720px] grid-cols-1 gap-4 sm:grid-cols-2">
//             {/* Payroll Period */}
//             <div>
//               <label
//                 htmlFor="payroll-period"
//                 className="mb-1.5 block text-xs font-medium text-gray-700"
//               >
//                 Payroll Period
//                 <span className="ml-1 text-red-500">*</span>
//               </label>

//               <select
//                 id="payroll-period"
//                 value={selectedPeriod}
//                 onChange={(e) =>
//                   handlePeriodChange(e.target.value)
//                 }
//                 className="
//                   h-10
//                   w-full
//                   rounded-md
//                   border
//                   border-gray-300
//                   bg-white
//                   px-3
//                   text-sm
//                   text-gray-700
//                   outline-none
//                   transition
//                   focus:border-primary-600
//                   focus:ring-1
//                   focus:ring-primary-600
//                 "
//               >
//                 <option value="">
//                   Select Payroll Period
//                 </option>

//                 {periods
//                   .filter((period) => period.status === "Active")
//                   .map((period) => (
//                     <option
//                       key={period.id}
//                       value={period.id}
//                     >
//                       {period.code} - {period.name}
//                     </option>
//                   ))
//                 }
//               </select>
//             </div>

//             {/* Payroll Batch */}
//             {/*
//             <div>
//               <label
//                 htmlFor="payroll-batch"
//                 className="mb-1.5 block text-xs font-medium text-gray-700"
//               >
//                 Payroll Batch
//               </label>

//               <select
//                 id="payroll-batch"
//                 value={selectedBatch}
//                 onChange={(e) =>
//                   setSelectedBatch(e.target.value)
//                 }
//                 disabled={!selectedPeriod}
//                 className="
//                   h-10
//                   w-full
//                   rounded-md
//                   border
//                   border-gray-300
//                   bg-white
//                   px-3
//                   text-sm
//                   text-gray-700
//                   outline-none
//                   transition
//                   focus:border-primary-600
//                   focus:ring-1
//                   focus:ring-primary-600
//                   disabled:cursor-not-allowed
//                   disabled:bg-gray-100
//                   disabled:text-gray-400
//                 "
//               >
//                 <option value="">
//                   Select Payroll Batch
//                 </option>

//                 {filteredBatches.map((batch) => (
//                   <option
//                     key={batch.id}
//                     value={batch.id}
//                   >
//                     {batch.batchNo} - {batch.name}
//                   </option>
//                 ))}
//               </select>
//             </div>
//             */}
//           </div>

//           {selectedPeriod && (
//             <div className="mt-4 flex flex-wrap items-center gap-3">
//               {/* <Button
//                 type="button"
//                 variant="contained"
//                 onClick={handleGeneratePayroll}
//                 disabled={running}
//                 startIcon={
//                   running ? (
//                     <RefreshCw
//                       size={15}
//                       className="animate-spin"
//                     />
//                   ) : (
//                     <Play size={15} />
//                   )
//                 }
//                 sx={{
//                   backgroundColor: PRIMARY,
//                   textTransform: "none",
//                   borderRadius: 1.5,
//                   boxShadow: "none",
//                   px: 2.5,
//                   "&:hover": {
//                     backgroundColor: "#145016",
//                     boxShadow: "none",
//                   },
//                 }}
//               >
//                 {running
//                   ? "Generating Payroll..."
//                   : "Generate Payroll"}
//               </Button> */}

//               <button
//                 type="button"
//                 onClick={handleRefreshPreview}
//                 disabled={previewLoading || running}
//                 className="
//                   inline-flex
//                   items-center
//                   justify-center
//                   gap-2
//                   rounded-md
//                   border
//                   border-gray-300
//                   bg-white
//                   px-4
//                   py-2.5
//                   text-sm
//                   font-medium
//                   text-gray-600
//                   transition-colors
//                   hover:border-primary-600
//                   hover:bg-primary-50
//                   hover:text-primary-700
//                   disabled:cursor-not-allowed
//                   disabled:bg-gray-100
//                   disabled:text-gray-400
//                 "
//               >
//                 <RefreshCw
//                   size={15}
//                   className={previewLoading ? "animate-spin" : ""}
//                 />

//                 Refresh Preview
//               </button>
//             </div>
//           )}

//           {selectedBatch && (
//             <p className="mt-3 text-xs text-gray-500">
//               {batchEmployeesLoading
//                 ? "Loading batch employees..."
//                 : `${batchEmployees.length} active employee(s) in this batch.`}
//             </p>
//           )}
//         </div>
//       </div>

//       {/* ─────────────────────────────────────────────────────────────
//           Payroll Preview
//       ───────────────────────────────────────────────────────────── */}
//       <div className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
//         <div className="flex flex-col gap-3 border-b border-gray-200 px-5 py-4 sm:flex-row sm:items-center sm:justify-between">
//           <div>
//             <h2 className="text-sm font-semibold text-gray-900">
//               Payroll Preview
//             </h2>

//             <p className="mt-0.5 text-xs text-gray-500">
//               Review calculated payroll amounts before submitting
//               the run for approval.
//             </p>
//           </div>

//           {preview.length > 0 && (
//             <div className="flex flex-wrap items-center gap-5 text-right">
//               <div>
//                 <p className="text-[11px] uppercase tracking-wide text-gray-400">
//                   Employees
//                 </p>
//                 <p className="text-sm font-semibold text-gray-900">
//                   {preview.length}
//                 </p>
//               </div>

//               <div>
//                 <p className="text-[11px] uppercase tracking-wide text-gray-400">
//                   Gross
//                 </p>
//                 <p className="text-sm font-semibold text-gray-900">
//                   {fmtMoney(totalGross)}
//                 </p>
//               </div>

//               <div>
//                 <p className="text-[11px] uppercase tracking-wide text-gray-400">
//                   Net Pay
//                 </p>
//                 <p
//                   className="text-sm font-semibold text-primary-700"
//                 >
//                   {fmtMoney(totalNet)}
//                 </p>
//               </div>
//             </div>
//           )}
//         </div>

//         {!selectedPeriod ? (
//           <div className="px-5 py-12 text-center">
//             <div className="mx-auto mb-3 flex h-10 w-10 items-center justify-center rounded-full bg-gray-100 text-gray-400">
//               <CalendarDays size={19} />
//             </div>

//             <p className="text-sm font-medium text-gray-700">
//               Select a payroll period
//             </p>

//             <p className="mt-1 text-xs text-gray-500">
//               Choose a payroll period above to generate and preview
//               payroll.
//             </p>
//           </div>
//         ) : (
//           <>
//             <Table
//               {...TABLE_PROPS}
//               loading={previewLoading}
//               rows={preview}
//               rowKey={(row) =>
//                 row.empNo || row.serviceNo || row.id
//               }
//               searchKeys={["empNo", "name"]}
//               searchPlaceholder="Search employees..."
//               columns={[
//                 {
//                   key: "name",
//                   label: "Employee",
//                   grow: true,
//                   className:
//                     "font-semibold text-gray-900",
//                   render: (r) =>
//                     `${r.name} (${r.empNo})`,
//                 },
//                 {
//                   key: "workingDays",
//                   label: "Working Days",
//                   align: "right",
//                   className: "text-gray-600 tabular-nums",
//                   render: (r) =>
//                     r.workingDays,
//                 },
//                 {
//                   key: "presentDays",
//                   label: "Present",
//                   align: "right",
//                   className: "text-gray-600 tabular-nums",
//                   render: (r) =>
//                     r.presentDays,
//                 },
//                 {
//                   key: "gross",
//                   label: "Gross (Rs)",
//                   align: "right",
//                   className:
//                     "font-semibold text-gray-900 tabular-nums",
//                   render: (r) =>
//                     fmtMoney(r.gross),
//                 },
//                 {
//                   key: "totalDeductions",
//                   label: "Deductions (Rs)",
//                   align: "right",
//                   className:
//                     "text-gray-600 tabular-nums",
//                   render: (r) =>
//                     fmtMoney(r.totalDeductions),
//                 },
//                 {
//                   key: "epf",
//                   label: "EPF (Rs)",
//                   align: "right",
//                   className:
//                     "text-gray-600 tabular-nums",
//                   render: (r) =>
//                     fmtMoney(r.epf),
//                 },
//                 {
//                   key: "net",
//                   label: "Net Pay (Rs)",
//                   align: "right",
//                   className:
//                     "font-semibold text-gray-900 tabular-nums",
//                   render: (r) =>
//                     fmtMoney(r.net),
//                 },
//                 {
//                   key: "breakdown",
//                   label: "Breakdown",
//                   align: "center",
//                   render: (r) => (
//                     <button
//                       type="button"
//                       onClick={() => {
//                         setSelectedPayroll(r);
//                         setBreakdownOpen(true);
//                       }}
//                       className="
//                         inline-flex
//                         h-8
//                         items-center
//                         gap-1.5
//                         rounded-md
//                         border
//                         border-gray-200
//                         px-2.5
//                         text-xs
//                         font-medium
//                         text-gray-600
//                         transition-colors
//                         hover:border-primary-200
//                         hover:bg-primary-50
//                         hover:text-primary-700
//                       "
//                     >
//                       <Eye size={14} />
//                       View
//                     </button>
//                   ),
//                 },
//               ]}
//             />

//             {preview.length > 0 && (
//               <div className="flex flex-col gap-2 border-t border-gray-200 px-5 py-4 sm:flex-row sm:items-center sm:justify-end">
//                 <button
//                   type="button"
//                   onClick={() => {
//                     setPreview([]);
//                     setSelectedPeriod("");
//                     setSelectedBatch("");
//                     setBatchEmployees([]);
//                   }}
//                   disabled={running}
//                   className="
//                     inline-flex
//                     items-center
//                     justify-center
//                     rounded-md
//                     border
//                     border-gray-300
//                     bg-white
//                     px-4
//                     py-2.5
//                     text-sm
//                     font-medium
//                     text-gray-600
//                     transition-colors
//                     hover:border-primary-600
//                     hover:bg-primary-50
//                     hover:text-primary-700
//                     disabled:cursor-not-allowed
//                     disabled:bg-gray-100
//                     disabled:text-gray-400
//                   "
//                 >
//                   Start New Run
//                 </button>

//                 <button
//                   type="button"
//                   onClick={handleOpenApprovalDialog}
//                   disabled={
//                     running ||
//                     previewLoading ||
//                     preview.length === 0
//                   }
//                   className="
//                     inline-flex
//                     items-center
//                     justify-center
//                     gap-2
//                     rounded-md
//                     bg-primary-600
//                     px-4
//                     py-2.5
//                     text-sm
//                     font-medium
//                     text-white
//                     transition-colors
//                     hover:bg-primary-700
//                     disabled:cursor-not-allowed
//                     disabled:bg-gray-300
//                     disabled:text-gray-500
//                   "
//                 >
//                   {/*running ? (
//                     <RefreshCw
//                       size={15}
//                       className="animate-spin"
//                     />
//                   ) : (
//                     <Send size={15} />
//                   )}

//                   {running ? "Processing..." : "Submit for Approval" */}

//                   <Send size={15} />
//                   Submit for Approval
//                 </button>
//               </div>
//             )}
//           </>
//         )}
//       </div>

//       <PayrollBreakdownDialog
//         open={breakdownOpen}
//         payroll={selectedPayroll}
//         onClose={() => {
//           setBreakdownOpen(false);
//           setSelectedPayroll(null);
//         }}
//       />

//       <PayrollApprovalProgressDialog 
//         open={approvalDialogOpen}
//         status={approvalStatus}
//         errorMessage={approvalError}
//         onConfirm={handleExecuteSubmission}
//         onClose={() => setApprovalDialogOpen(false)}
//       />

//       <Toast 
//         message={toast?.message}
//         type={toast?.type}
//         onClose={hideToast}
//       />
//     </div>
//   );
// };

// export default PayrollProcessing;


// import { useEffect, useState } from "react";
// import {
//   Box,
//   Paper,
//   Stepper,
//   Step,
//   StepLabel,
//   Button,
//   Typography,
//   MenuItem,
//   TextField,
//   Grid,
//   CircularProgress,
// } from "@mui/material";
// import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutlined";
// import { toast } from "react-toastify";
// import PageHeader from "../../../components/PageHeader/PageHeader";
// import DataTable from "../../../components/DataTable/DataTable";
// import usePayrollEntity from "../../../utils/usePayrollEntity";
// import { fmtRs, fmtMoney } from "../../../utils/payrollFormat";
// import { useDispatch } from "react-redux";
// import {
//   calculatePayroll,
//   getPayrollPreview,
//   getPayrollBatchEmployees,
//   validatePayrollBatch,
// } from "../../../store/slices/payrollSlice";
// import { getLoggedInServiceNo } from "../../../utils/masterDataUtils";
// import PayrollBreakdownDialog from "../../../components/PayRoll/PayrollBreakdownDialog";

// const PRIMARY = "#1B5C20";

// const STEPS = [
//   { label: "Generate Payroll", description: "Select the payroll period and employee batch to run." },
//   // { label: "Payroll Calculation", description: "Calculate earnings, deductions, EPF/ETF and PAYE for every employee in the batch." },
//   // { label: "Payroll Validation", description: "Validate the run against configured rules and flag exceptions." },
//   // { label: "Payroll Recalculation", description: "Recalculate after resolving any exceptions found during validation." },
//   { label: "Payroll Preview", description: "Preview the final payroll run before sending it for approval." },
// ];

// const PayrollProcessing = () => {
//   const [activeStep, setActiveStep] = useState(0);
//   const [running, setRunning] = useState(false);

//   const [selectedPeriod, setSelectedPeriod] = useState("");
//   const [selectedBatch, setSelectedBatch] = useState("");

//   const [preview, setPreview] = useState([]);
//   const [previewLoading, setPreviewLoading] = useState(false);

//   const [breakdownOpen, setBreakdownOpen] = useState(false);
//   const [selectedPayroll, setSelectedPayroll] = useState(null);

//   // Employees pulled from PayRollBatch/GetPayRollEmpBybatchId for the
//   // batch chosen in Step 1 — this is the "service numbers from the
//   // project's own Get API" that the Validation/Recalculation/Preview
//   // steps run against, instead of anyone typing service numbers by hand.
//   const [batchEmployees, setBatchEmployees] = useState([]);
//   const [batchEmployeesLoading, setBatchEmployeesLoading] = useState(false);

//   // const [validation, setValidation] = useState([]);
//   // const [validationLoading, setValidationLoading] = useState(false);

//   const dispatch = useDispatch();

//   // const { list: preview, loading } = usePayrollEntity("payrollPreview");
//   const { list: periods } = usePayrollEntity("payrollPeriods");
//   const { list: batches } = usePayrollEntity("batchManagement");

//   // Load the selected batch's active employees (service numbers) as soon
//   // as a batch is picked, so later steps have them ready to call
//   // PayRollCal/GetPayrollDetailsBySno and Preview/GetPreviewPayroll with.
//   useEffect(() => {
//     if (!selectedBatch) {
//       setBatchEmployees([]);
//       // setValidation([]);
//       return;
//     }

//     let cancelled = false;
//     setBatchEmployeesLoading(true);

//     dispatch(getPayrollBatchEmployees(selectedBatch))
//       .then((list) => {
//         if (!cancelled) setBatchEmployees(list);
//       })
//       .catch((error) => {
//         console.error("Failed to load batch employees: ", error);
//         if (!cancelled) setBatchEmployees([]);
//       })
//       .finally(() => {
//         if (!cancelled) setBatchEmployeesLoading(false);
//       });

//     return () => {
//       cancelled = true;
//     };
//   }, [selectedBatch, dispatch]);

//   useEffect(() => {
//     if (activeStep !== STEPS.length - 1) {
//       return;
//     }

//     if (!selectedPeriod) return;

//     const loadPreview = async () => {
//       setPreviewLoading(true);

//       try {
//         const result = await dispatch(
//           getPayrollPreview(selectedPeriod, batchEmployees)
//         );

//         setPreview(result || []);

//         if (!result || result.length === 0) {
//           toast.info(
//             "No employees with salary were found for the selected payroll period."
//           );
//         }
//       } catch (error) {
//         console.error("Payroll preview error: ", error);

//         setPreview([]);

//         toast.error(
//           error?.message || "Failed to load payroll preview."
//         );
//       } finally {
//         setPreviewLoading(false);
//       }
//     }

//     loadPreview();
//   }, [activeStep, selectedPeriod, batchEmployees, dispatch]);

//   const filteredBatches = selectedPeriod 
//     ? batches.filter(
//         (batch) => String(batch.periodId) === String(selectedPeriod)
//       )
//     : batches;

//   // const isCalculationStep = activeStep === 1;
//   // const isValidationStep = activeStep === 2;
//   // const isRecalculationStep = activeStep === 3;

//   // const runStep = async () => {
//   //   if (activeStep === 0) {
//   //     if (!selectedPeriod) {
//   //       toast.warning("Please select a payroll period");
//   //       return;
//   //     }
//   //   }

//   //   if ((isValidationStep || isRecalculationStep) && batchEmployees.length === 0) {
//   //     toast.warning(
//   //       "Please select a payroll batch with active employees in Step 1 first."
//   //     );
//   //     return;
//   //   }

//   //   setRunning(true);

//   //   try {
//   //     if (isCalculationStep) {
//   //       // Runs PayrollCal/CalPayRoll for the whole selected period.
//   //       await dispatch(calculatePayroll(selectedPeriod, getLoggedInServiceNo()));
//   //     } else if (isValidationStep || isRecalculationStep) {
//   //       if (isRecalculationStep) {
//   //         // Recalculation: re-run the calculation, then re-check every
//   //         // batch employee's record so exceptions found during
//   //         // Validation get picked up again.
//   //         await dispatch(calculatePayroll(selectedPeriod, getLoggedInServiceNo()));
//   //       }

//   //       setValidationLoading(true);

//   //       const results = await dispatch(
//   //         validatePayrollBatch(selectedPeriod, batchEmployees)
//   //       );

//   //       setValidation(results);
//   //       setValidationLoading(false);

//   //       const exceptions = results.filter((r) => r.status === "Exception").length;

//   //       if (exceptions > 0) {
//   //         toast.warning(
//   //           `${exceptions} of ${results.length} employee(s) still need attention.`,
//   //           { autoClose: 2500 }
//   //         );
//   //       }
//   //     } else {
//   //       // Step 1 (Generate Payroll) has nothing to call yet — the period
//   //       // and batch are just being selected.
//   //       await new Promise((resolve) => setTimeout(resolve, 400));
//   //     }

//   //     toast.success(`${STEPS[activeStep].label} completed.`, { autoClose: 1800 });
//   //     setActiveStep((s) => Math.min(s + 1, STEPS.length - 1));
//   //   } catch (error) {
//   //     console.error(`${STEPS[activeStep].label} failed: `, error);

//   //     toast.error(
//   //       error?.response?.data?.message || error?.response?.data?.Message ||
//   //       error?.message || `Failed to run ${STEPS[activeStep].label}.`
//   //     );
//   //   } finally {
//   //     setValidationLoading(false);
//   //     setRunning(false);
//   //   }
//   // };

//   const runStep = async () => {
//     // Only payroll period is mandatory
//     if (activeStep === 0) {
//       if (!selectedPeriod) {
//         toast.warning("Please select a payroll period");
//         return;
//       }
//     }

//     setRunning(true);

//     try {
//       if (activeStep < STEPS.length - 1) {
//         // Steps 1 - 4 are navigation only. No payroll calculation logic.
//         await new Promise((resolve) => setTimeout(resolve, 300));

//         toast.success(
//           `${STEPS[activeStep].label} completed.`,
//           { autoClose: 1800 }
//         );

//         setActiveStep((s) => Math.min(s+1, STEPS.length - 1));
//       }
//     } finally {
//       setRunning(false);
//     }
//   } 

//   const isPreviewStep = activeStep === STEPS.length - 1;
//   const totalGross = preview.reduce((s, r) => s + r.gross, 0);
//   const totalNet = preview.reduce((s, r) => s + r.net, 0);

//   const handleSubmitForApproval = async () => {
//     if (!selectedPeriod) {
//       toast.warning("Please select a payroll period.");
//       return;
//     }

//     setRunning(true);

//     try {
//       await dispatch(calculatePayroll(selectedPeriod, getLoggedInServiceNo()));
      
//       setPreview([]);

//       toast.success(
//         "Payroll generated successfully. The payroll preview has been cleared.",
//         { autoClose: 2500 }
//       );

//       // Return to step 1
//       setActiveStep(0);
//     } catch (error) {
//       console.error("Payroll generation error: ", error);

//       toast.error(
//         error?.response?.data?.message || error?.response?.data?.Message ||
//         error?.message || "Failed to generate payroll."
//       );
//     } finally {
//       setRunning(false);
//     }
//   }

//   return (
//     <Box>
//       <PageHeader
//         icon={<PlayCircleOutlineIcon sx={{ color: PRIMARY, fontSize: 28 }} />}
//         title="Payroll Processing"
//         subtitle="Generate, calculate, validate and preview a payroll run before approval."
//       />

//       <Paper elevation={0} sx={{ p: 3, borderRadius: 3, border: "1px solid #EAEAEA", mb: 3 }}>
//         <Stepper
//           activeStep={activeStep}
//           alternativeLabel
//           sx={{
//             mb: 3,
//             "& .MuiStepIcon-root.Mui-active": { color: PRIMARY },
//             "& .MuiStepIcon-root.Mui-completed": { color: PRIMARY },
//           }}
//         >
//           {STEPS.map((step) => (
//             <Step key={step.label}>
//               <StepLabel>{step.label}</StepLabel>
//             </Step>
//           ))}
//         </Stepper>

//         {!isPreviewStep && (
//           <>
//             <Typography variant="body2" color="#646464" sx={{ mb: 2 }}>
//               {STEPS[activeStep].description}
//             </Typography>

//             {activeStep === 0 && (
//               <div className="mb-4 grid max-w-[480px] grid-cols-1 gap-4 sm:grid-cols-2">
//                 {/* Payroll Period */}
//                 <div className="w-full">
//                   <label
//                     htmlFor="payroll-period"
//                     className="mb-1 block text-sm font-medium text-gray-700"
//                   >
//                     Payroll Period
//                   </label>

//                   <select
//                     id="payroll-period"
//                     value={selectedPeriod}
//                     onChange={(e) => {
//                       setSelectedPeriod(e.target.value);
//                       setSelectedBatch("");
//                     }}
//                     className="h-10 w-full rounded-md border border-gray-300 bg-white px-3 text-sm text-gray-700 outline-none transition focus:border-[#1B5C20] focus:ring-1 focus:ring-[#1B5C20]"
//                   >
//                     <option value="">Select Payroll Period</option>

//                     {periods.map((period) => (
//                       <option key={period.id} value={period.id}>
//                         {period.code} - {period.name}
//                       </option>
//                     ))}
//                   </select>
//                 </div>

//                 {/* Payroll Batch */}
//                 {/* <div className="w-full">
//                   <label
//                     htmlFor="payroll-batch"
//                     className="mb-1 block text-sm font-medium text-gray-700"
//                   >
//                     Payroll Batch
//                   </label>

//                   <select
//                     id="payroll-batch"
//                     value={selectedBatch}
//                     onChange={(e) => {
//                       setSelectedBatch(e.target.value);
//                     }}
//                     disabled={!selectedPeriod}
//                     className="h-10 w-full rounded-md border border-gray-300 bg-white px-3 text-sm text-gray-700 outline-none transition focus:border-[#1B5C20] focus:ring-1 focus:ring-[#1B5C20] disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-400"
//                   >
//                     <option value="">Select Payroll Batch</option>

//                     {filteredBatches.map((batch) => (
//                       <option key={batch.id} value={batch.id}>
//                         {batch.batchNo} - {batch.name}
//                       </option>
//                     ))}
//                   </select>
//                 </div> */}
//               </div>
//             )}

//             {activeStep === 0 && selectedBatch && (
//               <Typography variant="caption" color="#888" sx={{ display: "block", mb: 2 }}>
//                 {batchEmployeesLoading
//                   ? "Loading batch employees..."
//                   : `${batchEmployees.length} active employee(s) in this batch.`}
//               </Typography>
//             )}

//             <Button
//               variant="contained"
//               onClick={runStep}
//               disabled={running}
//               startIcon={running ? <CircularProgress size={16} sx={{ color: "#fff" }} /> : null}
//               sx={{
//                 backgroundColor: PRIMARY,
//                 textTransform: "none",
//                 borderRadius: 2,
//                 px: 3,
//                 "&:hover": { backgroundColor: "#145016" },
//               }}
//             >
//               {running ? "Processing..." : `Run: ${STEPS[activeStep].label}`}
//             </Button>

//             {/* {(isValidationStep || isRecalculationStep) && validation.length > 0 && (
//               <Box sx={{ mt: 3 }}>
//                 <DataTable
//                   loading={validationLoading}
//                   rows={validation}
//                   searchKeys={["empNo", "name"]}
//                   searchPlaceholder="Search employees..."
//                   pageSize={6}
//                   columns={[
//                     { key: "name", label: "Employee", render: (r) => `${r.name} (${r.empNo})` },
//                     { key: "gross", label: "Gross (Rs)", align: "right", render: (r) => fmtMoney(r.gross) },
//                     { key: "totalDeductions", label: "Deductions (Rs)", align: "right", render: (r) => fmtMoney(r.totalDeductions) },
//                     { key: "net", label: "Net Pay (Rs)", align: "right", render: (r) => fmtMoney(r.net) },
//                     {
//                       key: "status",
//                       label: "Status",
//                       render: (r) => (
//                         <Typography
//                           variant="body2"
//                           sx={{ fontWeight: 600, color: r.status === "OK" ? PRIMARY : "#C62828" }}
//                         >
//                           {r.status}
//                         </Typography>
//                       ),
//                     },
//                     { key: "message", label: "Details" },
//                   ]}
//                 />
//               </Box>
//             )} */}
//           </>
//         )}

//         {isPreviewStep && (
//           <>
//             <Typography variant="body2" color="#646464" sx={{ mb: 2 }}>
//               {STEPS[activeStep].description} Gross: <b>{fmtMoney(totalGross)}</b> &nbsp;|&nbsp; Net:{" "}
//               <b style={{ color: PRIMARY }}>{fmtMoney(totalNet)}</b>
//             </Typography>
//             <DataTable
//               loading={previewLoading}
//               rows={preview}
//               searchKeys={["empNo", "name"]}
//               searchPlaceholder="Search employees..."
//               pageSize={6}
//               columns={[
//                 { key: "name", label: "Employee", render: (r) => `${r.name} (${r.empNo})` },
//                 { key: "workingDays", label: "Working Days", align: "right", render: (r) => r.workingDays },
//                 { key: "presentDays", label: "Present", align: "right", render: (r) => r.presentDays },
//                 { key: "gross", label: "Gross (Rs)", align: "right", render: (r) => fmtMoney(r.gross) },
//                 { key: "totalDeductions", label: "Deductions (Rs)", align: "right", render: (r) => fmtMoney(r.totalDeductions) },
//                 { key: "epf", label: "EPF (Rs)", align: "right", render: (r) => fmtMoney(r.epf) },
//                 { key: "net", label: "Net Pay (Rs)", align: "right", render: (r) => fmtMoney(r.net) },

//                 {
//                   key: "breakdown",
//                   label: "Breakdown",
//                   align: "center",
//                   render: (r) => (
//                     <Button
//                       size="small"
//                       variant="outlined"
//                       onClick={() => {
//                         setSelectedPayroll(r);
//                         setBreakdownOpen(true);
//                       }}
//                       sx={{
//                         textTransform: "none",
//                         borderColor: PRIMARY,
//                         color: PRIMARY,
//                         borderRadius: 1.5,
//                         fontSize: "0.75rem",
//                         "&:hover": {
//                           borderColor: PRIMARY,
//                           backgroundColor: "#F0F7F0",
//                         },
//                       }}  
//                     >
//                       View Breakdown
//                     </Button>
//                   )
//                 }
//               ]}
//             />
//             <Box sx={{ mt: 2, display: "flex", gap: 1.5 }}>
//               <Button
//                 variant="outlined"
//                 onClick={() => setActiveStep(0)}
//                 sx={{ textTransform: "none", borderColor: PRIMARY, color: PRIMARY, borderRadius: 2 }}
//               >
//                 Start New Run
//               </Button>
//               <Button
//                 variant="contained"
//                 onClick={handleSubmitForApproval}
//                 disabled={running || previewLoading || preview.length === 0}
//                 sx={{ backgroundColor: PRIMARY, textTransform: "none", borderRadius: 2, "&:hover": { backgroundColor: "#145016" } }}
//               >
//                 { running ? "Generating Payroll..." : "Submit for Approval" }
//               </Button>
//             </Box>
//           </>
//         )}
//       </Paper>

//       <PayrollBreakdownDialog 
//         open={breakdownOpen}
//         payroll={selectedPayroll}
//         onClose={() => {
//           setBreakdownOpen(false);
//           setSelectedPayroll(null);
//         }}
//       />
//     </Box>
//   );
// };

// export default PayrollProcessing;


// -------------------------------------------------------------------------------------------------------------
// ------------ VERSION 3 : PROPERLY WORKING WITHOUT SALARY ADVANCE MODE ----------------------------------------
// -------------------------------------------------------------------------------------------------------------

// import { useEffect, useState } from "react";
// import { useDispatch } from "react-redux";
// import {
//   CalendarDays,
//   Play,
//   RefreshCw,
//   Send,
//   Eye,
// } from "lucide-react";
// import { toast } from "react-toastify";

// import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
// import Table from "../../../components/Table/Table";
// import ExcelJS from 'exceljs';
// import { saveAs } from 'file-saver'
// import { Download } from "lucide-react";

// import usePayrollEntity from "../../../utils/usePayrollEntity";
// import { fmtMoney } from "../../../utils/payrollFormat";
// import { getLoggedInServiceNo } from "../../../utils/masterDataUtils";
// import {
//   calculatePayroll,
//   getPayrollPreview,
//   getPayrollBatchEmployees,
// } from "../../../store/slices/payrollSlice";

// import PayrollBreakdownDialog from "../../../components/PayRoll/PayrollBreakdownDialog";
// import Toast from "../../../components/Toast/Toast";
// import SearchableSelect from "../../../components/common/SearchableSelect";
// import useToast from "../../../utils/useToast";
// import PayrollApprovalProgressDialog, { APPROVAL_STATUS } from "../../../components/PayRoll/PayrollApprovalProgressDialog";
// import payRollService from "../../../services/PayrollService";

// const TABLE_PROPS = {
//   search: true,
//   searchLabel: "Search",
//   pageSize: 10,
//   scrollClassName: "",
//   emptyMessage: "No payroll records found",
//   loadingMessage: "Loading...",
// };

// const PayrollProcessing = () => {
//   const dispatch = useDispatch();

//   const [running, setRunning] = useState(false);

//   const [selectedPeriod, setSelectedPeriod] = useState("");
//   const [selectedBatch, setSelectedBatch] = useState("");

//   const [preview, setPreview] = useState([]);
//   const [previewLoading, setPreviewLoading] = useState(false);

//   const [breakdownOpen, setBreakdownOpen] = useState(false);
//   const [selectedPayroll, setSelectedPayroll] = useState(null);

//   const [batchEmployees, setBatchEmployees] = useState([]);
//   const [batchEmployeesLoading, setBatchEmployeesLoading] = useState(false);

//   const [approvalDialogOpen, setApprovalDialogOpen] = useState(false);
//   const [approvalStatus, setApprovalStatus] = useState(APPROVAL_STATUS.IDLE);
//   const [approvalError, setApprovalError] = useState('');

//   const { list: periods } = usePayrollEntity("payrollPeriods");
//   const { list: batches } = usePayrollEntity("batchManagement");

//   const { toast, showToast, hideToast } = useToast();

//   /*
//    * Load employees belonging to the selected batch.
//    */
//   useEffect(() => {
//     if (!selectedBatch) {
//       setBatchEmployees([]);
//       return;
//     }

//     let cancelled = false;

//     setBatchEmployeesLoading(true);

//     dispatch(getPayrollBatchEmployees(selectedBatch))
//       .then((list) => {
//         if (!cancelled) {
//           setBatchEmployees(list || []);
//         }
//       })
//       .catch((error) => {
//         console.error("Failed to load batch employees:", error);

//         if (!cancelled) {
//           setBatchEmployees([]);
//         }
//       })
//       .finally(() => {
//         if (!cancelled) {
//           setBatchEmployeesLoading(false);
//         }
//       });

//     return () => {
//       cancelled = true;
//     };
//   }, [selectedBatch, dispatch]);

//   /*
//    * Load preview whenever a payroll period is selected and
//    * the preview is requested by the existing flow.
//    */
//   useEffect(() => {
//     if (!selectedPeriod) {
//       setPreview([]);
//       return;
//     }

//     const loadPreview = async () => {
//       setPreviewLoading(true);

//       try {
//         const result = await dispatch(
//           getPayrollPreview(selectedPeriod, batchEmployees)
//         );

//         setPreview(result || []);

//         if (!result || result.length === 0) {
//           // toast.info(
//           //   "No employees with salary were found for the selected payroll period."
//           // );

//           showToast("The selected payroll period has already been generated.", 'warning');
//         }
//       } catch (error) {
//         console.error("Payroll preview error:", error);

//         setPreview([]);

//         // toast.error(
//         //   error?.message || "Failed to load payroll preview."
//         // );

//         showToast(error?.message || "Failed to load payroll preview.", 'error');
//       } finally {
//         setPreviewLoading(false);
//       }
//     };

//     loadPreview();
//   }, [selectedPeriod, batchEmployees, dispatch]);

//   const filteredBatches = selectedPeriod
//     ? batches.filter(
//         (batch) =>
//           String(batch.periodId) === String(selectedPeriod)
//       )
//     : batches;

//   const totalGross = preview.reduce(
//     (sum, row) => sum + Number(row.gross || 0),
//     0
//   );

//   const totalNet = preview.reduce(
//     (sum, row) => sum + Number(row.net || 0),
//     0
//   );

//   const handlePeriodChange = (value) => {
//     setSelectedPeriod(value);
//     setSelectedBatch("");
//     setPreview([]);
//   };

//   const handleOpenApprovalDialog = () => {
//     if (!selectedPeriod) {
//       showToast("Please select a payroll period.", "warning");
//       return;
//     }

//     if (preview.length === 0) {
//       showToast("There are no payroll records available for approval.", "warning");
//       return;
//     }

//     setApprovalStatus(APPROVAL_STATUS.IDLE);
//     setApprovalError('');
//     setApprovalDialogOpen(true);
//   }

//   const handleExecuteSubmission = async () => {
//     setRunning(true);

//     try {
//       // 1. Calculate payroll
//       setApprovalStatus(APPROVAL_STATUS.GENERATING_PAYROLL);
//       await dispatch(
//         calculatePayroll(selectedPeriod, getLoggedInServiceNo())
//       );

//       // 2. Generate bank report transfer
//       setApprovalStatus(APPROVAL_STATUS.GENERATING_BANK_REPORT);
//       const bankResponse = await payRollService.GetBankReportDetailsByPeriodId(selectedPeriod);

//       if (bankResponse && bankResponse.StatusCode !== 200) {
//         throw new Error(bankResponse.Result || "Failed to generate bank report.");
//       }

//       // Finished successfully
//       setApprovalStatus(APPROVAL_STATUS.COMPLETED);
//       setPreview([]);
//       setSelectedPeriod("");
//       setSelectedBatch("");
//       setBatchEmployees([]);
//     } catch (error) {
//       console.error("[Payroll Processing] Submission workflow failed: ", error);
//       const msg = 
//         error?.response?.data?.message || 
//         error?.response?.data?.Message || 
//         error?.message ||
//         "Failed to complete payroll submission.";
//       setApprovalError(msg);
//       setApprovalStatus(APPROVAL_STATUS.FAILED); 
//     } finally {
//       setRunning(false);
//     }
//   }

//   const handleRefreshPreview = async () => {
//     if (!selectedPeriod) {
//       // toast.warning("Please select a payroll period.");
//       showToast("Please select a payroll period.", "warning");
//       return;
//     }

//     setPreviewLoading(true);

//     try {
//       const result = await dispatch(
//         getPayrollPreview(
//           selectedPeriod,
//           batchEmployees
//         )
//       );

//       setPreview(result || []);

//       // toast.success("Payroll preview refreshed.", {
//       //   autoClose: 1500,
//       // });
//       showToast("Payroll preview refreshed.", "success");
//     } catch (error) {
//       console.error("Payroll preview error:", error);

//       // toast.error(
//       //   error?.message || "Failed to refresh payroll preview."
//       // );

//       showToast(error?.message || "Failed to refresh payroll preview.", "error");
//     } finally {
//       setPreviewLoading(false);
//     }
//   };
  
//   const handleDownloadExcel = async () => {
//     if (!preview || preview.length === 0) return;

//     const detailedPreviewList = await Promise.all(
//       preview.map(async (row) => {
//         try {
//           const response = await payRollService.GetPreviewPayroll(selectedPeriod, row.employeeId);
//           return response?.data?.ResultSet || null;
//         } catch {
//           return null;
//         }
//       })
//     );

//     const validDetails = detailedPreviewList.filter(Boolean);

//     const earningCompNames = new Set();
//     const deductionCompNames = new Set();

//     validDetails.forEach((res) => {
//       res.Details?.forEach((d) => {
//         const name = d.COMPONENT_NAME;
//         if (!name) return;

//         const code = String(d.COMPONENT_CODE || '').toUpperCase();
//         if (code === 'BASIC' || code === 'BASIC-SAL' || code === 'EPF-EE') return;

//         if (d.COMPONENT_TYPE === 'E') earningCompNames.add(name);
//         else if (d.COMPONENT_TYPE === 'D') deductionCompNames.add(name);
//       });
//     });

//     const dynamicEarnings = Array.from(earningCompNames);
//     const dynamicDeductions = Array.from(deductionCompNames);

//     const headers = [
//       'No',
//       'Payroll No',
//       'Pay Date',
//       'Service No',
//       'Employee Name',
//       'Working Days',
//       'Present Days',
//       'No-Pay Days',
//       'OT Hours',
//       'Gross Earnings (Rs)',
//       'Total Earnings to Gross (Rs)',
//       'Total Deductions from Gross (Rs)',
//       'Employee EPF 8% (Rs)',
//       ...dynamicEarnings.map((name) => `${name} (Rs)`),
//       ...dynamicDeductions.map((name) => `${name} (Rs)`),
//       'Employer EPF 12% (Rs)',
//       'Employer ETF 3% (Rs)',
//       'Net Salary (Rs)',
//     ];

//     const workbook = new ExcelJS.Workbook();
//     const periodObj = periods.find((p) => String(p.id) === String(selectedPeriod));
//     const periodName = periodObj?.name || 'Payroll_Preview';
//     const worksheet = workbook.addWorksheet('Payroll Preview');

//     const headerRow = worksheet.addRow(headers);
//     headerRow.height = 24;

//     headerRow.eachCell((cell) => {
//       cell.font = { name: 'Calibri', size: 10, bold: true, color: { argb: 'FF9A3412' } };
//       cell.fill = {
//         type: 'pattern',
//         pattern: 'solid',
//         fgColor: { argb: 'FFFFF7ED' },
//       };
//       cell.alignment = { vertical: 'middle', horizontal: 'center' };
//       cell.border = {
//         top: { style: 'thin', color: { argb: 'FF000000' } },
//         bottom: { style: 'thin', color: { argb: 'FF000000' } },
//         left: { style: 'thin', color: { argb: 'FF000000' } },
//         right: { style: 'thin', color: { argb: 'FF000000' } },
//       };
//     });

//     const borderBlack = {
//       top: { style: 'thin', color: { argb: 'FF000000' } },
//       bottom: { style: 'thin', color: { argb: 'FF000000' } },
//       left: { style: 'thin', color: { argb: 'FF000000' } },
//       right: { style: 'thin', color: { argb: 'FF000000' } },
//     };

//     preview.forEach((row, index) => {
//       const detailObj = validDetails.find((d) => String(d.Summary?.[0]?.EMPLOYEE_ID) === String(row.employeeId));
//       const summary = detailObj?.Summary?.[0] || {};
//       const componentDetails = detailObj?.Details || [];

//       const compMap = {};
//       componentDetails.forEach((d) => {
//         compMap[d.COMPONENT_NAME] = Number(d.AMOUNT || 0);
//       });

//       const rowValues = [
//         index + 1,
//         summary.PAYROLL_NO || '-',
//         summary.PAY_DATE ? String(summary.PAY_DATE).split(' ')[0] : '-',
//         row.empNo,
//         row.name,
//         Number(summary.WORKING_DAYS ?? row.workingDays ?? 0),
//         Number(summary.PRESENT_DAYS ?? row.presentDays ?? 0),
//         Number(summary.NO_PAY_DAYS ?? row.noPayDays ?? 0),
//         Number(summary.OT_HOURS ?? row.otHours ?? 0),
//         Number(summary.TOTAL_EARNINGS ?? row.gross ?? 0),
//         Number(summary.TOTAL_EARNINGS ?? row.totalEarnings ?? 0),
//         Number(summary.TOTAL_DEDUCTIONS ?? row.totalDeductions ?? 0),
//         Number(summary.EMPLOYEE_EPF ?? row.epf ?? 0),
//         ...dynamicEarnings.map((name) => (compMap[name] !== undefined ? compMap[name] : "-")),
//         ...dynamicDeductions.map((name) => (compMap[name] !== undefined ? compMap[name] : "-")),
//         Number(summary.EMPLOYER_EPF ?? row.employerEpf ?? 0),
//         Number(summary.EMPLOYER_ETF ?? row.employerEtf ?? 0),
//         Number(summary.NET_SALARY ?? row.net ?? 0),
//       ];

//       const addedRow = worksheet.addRow(rowValues);
//       addedRow.height = 20;

//       addedRow.eachCell((cell, colNumber) => {
//         const colIdx = colNumber - 1;
//         const isCurrency = colIdx >= 9;
//         const isCenter = (colIdx >= 5 && colIdx <= 8) || colIdx === 0 || colIdx === 2;

//         cell.font = { name: 'Calibri', size: 10, color: { argb: 'FF374151' } };
//         cell.border = borderBlack;

//         if (cell.value === "-") {
//           cell.alignment = { vertical: 'middle', horizontal: 'center' }
//         } else if (isCurrency) {
//           cell.alignment = { vertical: 'middle', horizontal: 'right' };
//           cell.numFmt = '#,##0.00';
//         } else if (isCenter) {
//           cell.alignment = { vertical: 'middle', horizontal: 'center' };
//         } else {
//           cell.alignment = { vertical: 'middle', horizontal: 'left' };
//         }
//       });
//     });

//     // Auto Column Widths
//     worksheet.columns.forEach((col) => {
//       let maxLen = 0;
//       col.eachCell({ includeEmpty: false }, (cell) => {
//         const str = cell.value ? cell.value.toString() : '';
//         if (str.length > maxLen) maxLen = str.length;
//       });
//       col.width = Math.max(maxLen + 3, 11);
//     });

//     // Save file
//     const buffer = await workbook.xlsx.writeBuffer();
//     const blob = new Blob([buffer], {
//       type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
//     });

//     saveAs(blob, `${periodName.replace(/[^a-zA-Z0-9_-]/g, '_')}_Preview_Summary.xlsx`);
//   }

//   const handleSubmitForApproval = async () => {
//     if (!selectedPeriod) {
//       // toast.warning("Please select a payroll period.");
//       showToast("Please select a payroll period.", "warning");
//       return;
//     }

//     if (preview.length === 0) {
//       // toast.warning(
//       //   "There are no payroll records available for approval."
//       // );
//       showToast("There are no payroll records available for approval.", "warning");
//       return;
//     }

//     setRunning(true);

//     try {
//       await dispatch(
//         calculatePayroll(
//           selectedPeriod,
//           getLoggedInServiceNo()
//         )
//       );

//       setPreview([]);

//       // toast.success(
//       //   "Payroll generated successfully. The payroll preview has been cleared.",
//       //   { autoClose: 2500 }
//       // );

//       showToast("Payroll generated successfully. The payroll preview has been cleared.", "success");

//       setSelectedPeriod("");
//       setSelectedBatch("");
//       setBatchEmployees([]);
//     } catch (error) {
//       console.error("Payroll generation error:", error);

//       // toast.error(
//       //   error?.response?.data?.message ||
//       //     error?.response?.data?.Message ||
//       //     error?.message ||
//       //     "Failed to generate payroll."
//       // );

//       showToast(`${error?.response?.data?.message ||
//           error?.response?.data?.Message ||
//           error?.message ||
//           "Failed to generate payroll."}`,"error")
//     } finally {
//       setRunning(false);
//     }
//   };

//   return (
//     <div className="space-y-4 p-6">
//       <Breadcrumb
//         trail={["Payroll", "Payroll Processing"]}
//         title="Payroll Processing"
//         subtitle="Generate payroll and review the final payroll results before approval."
//       />

//       {/* ─────────────────────────────────────────────────────────────
//           Payroll Generation
//       ───────────────────────────────────────────────────────────── */}
//       <div className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
//         <div className="px-5 py-4">
//           <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">

//             {/* Left: Title + Subtitle */}
//             <div className="flex items-center gap-3">
//               <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary-50 text-primary-700">
//                 <CalendarDays size={18} />
//               </div>

//               <div>
//                 <h2 className="text-sm font-semibold text-gray-900">
//                   Generate Payroll
//                 </h2>

//                 <p className="mt-0.5 text-xs text-gray-500">
//                   Select a payroll period and generate the payroll calculation.
//                 </p>
//               </div>
//             </div>

//             {/* Right: Payroll Period + Refresh Preview */}
//             <div className="flex flex-col gap-3 sm:flex-row sm:items-end">

//               {/* Payroll Period */}
//               <div className="w-full sm:w-[280px]">
//                 <label
//                   htmlFor="payroll-period"
//                   className="mb-1.5 block text-xs font-medium text-gray-700"
//                 >
//                   Payroll Period
//                   <span className="ml-1 text-red-500">*</span>
//                 </label>

//                 <SearchableSelect
//                   id="payroll-period"
//                   value={selectedPeriod}
//                   onChange={handlePeriodChange}
//                   options={periods
//                     .filter((period) => period.status === "Active")
//                     .map((period) => ({ value: period.id, label: `${period.code} - ${period.name}` }))}
//                   emptyOption={{ value: "", label: "Select Payroll Period" }}
//                   placeholder="Select Payroll Period"
//                   searchPlaceholder="Search payroll period..."
//                   className="h-10 w-full rounded-md border border-gray-300 bg-white px-3 text-sm text-gray-700 outline-none transition focus:border-primary-600 focus:ring-1 focus:ring-primary-600"
//                 />
//               </div>

//               {/* Refresh Preview */}
//               <button
//                 type="button"
//                 onClick={handleRefreshPreview}
//                 disabled={!selectedPeriod || previewLoading || running}
//                 className="
//                   inline-flex
//                   h-10
//                   shrink-0
//                   items-center
//                   justify-center
//                   gap-2
//                   rounded-md
//                   border
//                   border-gray-300
//                   bg-white
//                   px-4
//                   text-sm
//                   font-medium
//                   text-gray-600
//                   transition-colors
//                   hover:border-primary-600
//                   hover:bg-primary-50
//                   hover:text-primary-700
//                   disabled:cursor-not-allowed
//                   disabled:bg-gray-100
//                   disabled:text-gray-400
//                 "
//               >
//                 <RefreshCw
//                   size={15}
//                   className={previewLoading ? "animate-spin" : ""}
//                 />

//                 Refresh Preview
//               </button>

//               {preview.length > 0 && (
//                 <button
//                   type="button"
//                   onClick={handleDownloadExcel}
//                   disabled={previewLoading || running}
//                   className="
//                     inline-flex
//                     h-10
//                     shrink-0
//                     items-center
//                     justify-center
//                     gap-2
//                     rounded-md
//                     bg-amber-600
//                     px-4
//                     text-sm
//                     font-medium
//                     text-white
//                     transition-colors
//                     hover:bg-amber-700
//                     shadow-xs
//                     disabled:cursor-not-allowed
//                     disabled:bg-gray-300
//                     disabled:text-gray-500
//                   "
//                 >
//                   <Download size={15} />
//                   Export to Excel
//                 </button>
//               )}
//             </div>
//           </div>

//           {/* Optional batch employee information */}
//           {selectedBatch && (
//             <p className="mt-3 text-xs text-gray-500">
//               {batchEmployeesLoading
//                 ? "Loading batch employees..."
//                 : `${batchEmployees.length} active employee(s) in this batch.`}
//             </p>
//           )}
//         </div>
//       </div>


//       {/* ─────────────────────────────────────────────────────────────
//           Payroll Preview
//       ───────────────────────────────────────────────────────────── */}
//       <div className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
//         <div className="flex flex-col gap-3 border-b border-gray-200 px-5 py-4 sm:flex-row sm:items-center sm:justify-between">
//           <div>
//             <h2 className="text-sm font-semibold text-gray-900">
//               Payroll Preview
//             </h2>

//             <p className="mt-0.5 text-xs text-gray-500">
//               Review calculated payroll amounts before submitting
//               the run for approval.
//             </p>
//           </div>

//           {preview.length > 0 && (
//             <div className="flex flex-wrap items-center gap-5 text-right">
//               <div>
//                 <p className="text-[11px] uppercase tracking-wide text-gray-400">
//                   Employees
//                 </p>
//                 <p className="text-sm font-semibold text-gray-900">
//                   {preview.length}
//                 </p>
//               </div>

//               <div>
//                 <p className="text-[11px] uppercase tracking-wide text-gray-400">
//                   Gross
//                 </p>
//                 <p className="text-sm font-semibold text-gray-900">
//                   {fmtMoney(totalGross)}
//                 </p>
//               </div>

//               <div>
//                 <p className="text-[11px] uppercase tracking-wide text-gray-400">
//                   Net Pay
//                 </p>
//                 <p
//                   className="text-sm font-semibold text-primary-700"
//                 >
//                   {fmtMoney(totalNet)}
//                 </p>
//               </div>
//             </div>
//           )}
//         </div>

//         {!selectedPeriod ? (
//           <div className="px-5 py-12 text-center">
//             <div className="mx-auto mb-3 flex h-10 w-10 items-center justify-center rounded-full bg-gray-100 text-gray-400">
//               <CalendarDays size={19} />
//             </div>

//             <p className="text-sm font-medium text-gray-700">
//               Select a payroll period
//             </p>

//             <p className="mt-1 text-xs text-gray-500">
//               Choose a payroll period above to generate and preview
//               payroll.
//             </p>
//           </div>
//         ) : (
//           <>
//             <Table
//               {...TABLE_PROPS}
//               loading={previewLoading}
//               rows={preview}
//               rowKey={(row) =>
//                 row.empNo || row.serviceNo || row.id
//               }
//               searchKeys={["empNo", "name"]}
//               searchPlaceholder="Search employees..."
//               columns={[
//                 {
//                   key: "name",
//                   label: "Employee",
//                   grow: true,
//                   className:
//                     "font-semibold text-gray-900",
//                   render: (r) =>
//                     `${r.name} (${r.empNo})`,
//                 },
//                 {
//                   key: "workingDays",
//                   label: "Working Days",
//                   align: "right",
//                   className: "text-gray-600 tabular-nums",
//                   render: (r) =>
//                     r.workingDays,
//                 },
//                 {
//                   key: "presentDays",
//                   label: "Present",
//                   align: "right",
//                   className: "text-gray-600 tabular-nums",
//                   render: (r) =>
//                     r.presentDays,
//                 },
//                 {
//                   key: "gross",
//                   label: "Gross (Rs)",
//                   align: "right",
//                   className:
//                     "font-semibold text-gray-900 tabular-nums",
//                   render: (r) =>
//                     fmtMoney(r.gross),
//                 },
//                 {
//                   key: "totalDeductions",
//                   label: "Deductions (Rs)",
//                   align: "right",
//                   className:
//                     "text-gray-600 tabular-nums",
//                   render: (r) =>
//                     fmtMoney(r.totalDeductions),
//                 },
//                 {
//                   key: "epf",
//                   label: "EPF (Rs)",
//                   align: "right",
//                   className:
//                     "text-gray-600 tabular-nums",
//                   render: (r) =>
//                     fmtMoney(r.epf),
//                 },
//                 {
//                   key: "net",
//                   label: "Net Pay (Rs)",
//                   align: "right",
//                   className:
//                     "font-semibold text-gray-900 tabular-nums",
//                   render: (r) =>
//                     fmtMoney(r.net),
//                 },
//                 {
//                   key: "breakdown",
//                   label: "Breakdown",
//                   align: "center",
//                   render: (r) => (
//                     <button
//                       type="button"
//                       onClick={() => {
//                         setSelectedPayroll(r);
//                         setBreakdownOpen(true);
//                       }}
//                       className="
//                         inline-flex
//                         h-8
//                         items-center
//                         gap-1.5
//                         rounded-md
//                         border
//                         border-gray-200
//                         px-2.5
//                         text-xs
//                         font-medium
//                         text-gray-600
//                         transition-colors
//                         hover:border-primary-200
//                         hover:bg-primary-50
//                         hover:text-primary-700
//                       "
//                     >
//                       <Eye size={14} />
//                       View
//                     </button>
//                   ),
//                 },
//               ]}
//             />

//             {preview.length > 0 && (
//               <div className="flex flex-col gap-2 border-t border-gray-200 px-5 py-4 sm:flex-row sm:items-center sm:justify-end">
//                 <button
//                   type="button"
//                   onClick={() => {
//                     setPreview([]);
//                     setSelectedPeriod("");
//                     setSelectedBatch("");
//                     setBatchEmployees([]);
//                   }}
//                   disabled={running}
//                   className="
//                     inline-flex
//                     items-center
//                     justify-center
//                     rounded-md
//                     border
//                     border-gray-300
//                     bg-white
//                     px-4
//                     py-2.5
//                     text-sm
//                     font-medium
//                     text-gray-600
//                     transition-colors
//                     hover:border-primary-600
//                     hover:bg-primary-50
//                     hover:text-primary-700
//                     disabled:cursor-not-allowed
//                     disabled:bg-gray-100
//                     disabled:text-gray-400
//                   "
//                 >
//                   Start New Run
//                 </button>

//                 <button
//                   type="button"
//                   onClick={handleOpenApprovalDialog}
//                   disabled={
//                     running ||
//                     previewLoading ||
//                     preview.length === 0
//                   }
//                   className="
//                     inline-flex
//                     items-center
//                     justify-center
//                     gap-2
//                     rounded-md
//                     bg-primary-600
//                     px-4
//                     py-2.5
//                     text-sm
//                     font-medium
//                     text-white
//                     transition-colors
//                     hover:bg-primary-700
//                     disabled:cursor-not-allowed
//                     disabled:bg-gray-300
//                     disabled:text-gray-500
//                   "
//                 >
//                   {/*running ? (
//                     <RefreshCw
//                       size={15}
//                       className="animate-spin"
//                     />
//                   ) : (
//                     <Send size={15} />
//                   )}

//                   {running ? "Processing..." : "Submit for Approval" */}

//                   <Send size={15} />
//                   Submit for Approval
//                 </button>
//               </div>
//             )}
//           </>
//         )}
//       </div>

//       <PayrollBreakdownDialog
//         open={breakdownOpen}
//         payroll={selectedPayroll}
//         onClose={() => {
//           setBreakdownOpen(false);
//           setSelectedPayroll(null);
//         }}
//       />

//       <PayrollApprovalProgressDialog 
//         open={approvalDialogOpen}
//         status={approvalStatus}
//         errorMessage={approvalError}
//         onConfirm={handleExecuteSubmission}
//         onClose={() => setApprovalDialogOpen(false)}
//       />

//       <Toast 
//         message={toast?.message}
//         type={toast?.type}
//         onClose={hideToast}
//       />
//     </div>
//   );
// };

// export default PayrollProcessing;

// -------------------------------------------------------------------------------------------------------------
// ------------ VERSION 4 : PAYROLL PROCESSING + SALARY ADVANCE MODE -------------------------------------------
// -------------------------------------------------------------------------------------------------------------
import { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  CalendarDays,
  RefreshCw,
  Send,
  Eye,
  Download,
  Upload,
  CheckCircle2,
  AlertCircle,
  Loader2,
  FileSpreadsheet,
  Coins,
  ArrowRight,
  Check,
} from "lucide-react";
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import Table from "../../../components/Table/Table";
import SearchableSelect from "../../../components/common/SearchableSelect";
import Toast from "../../../components/Toast/Toast";
import PayrollBreakdownDialog from "../../../components/PayRoll/PayrollBreakdownDialog";
import PayrollApprovalProgressDialog, { APPROVAL_STATUS } from "../../../components/PayRoll/PayrollApprovalProgressDialog";

import usePayrollEntity from "../../../utils/usePayrollEntity";
import { fmtMoney } from "../../../utils/payrollFormat";
import { getLoggedInServiceNo } from "../../../utils/masterDataUtils";
import useToast from "../../../utils/useToast";

import {
  calculatePayroll,
  getPayrollPreview,
  getPayrollBatchEmployees,
  fetchPayrollEntityList,
} from "../../../store/slices/payrollSlice";
import { fetchAllEmployees } from "../../../store/slices/employeeSlice";

import payRollService from "../../../services/PayrollService";
import PayrollBatchEmployeeService from "../../../services/PayrollBatchEmployeeService";
import {
  readBatchWorkbook,
  validateBatchRow,
  downloadBatchEmployeeTemplate,
} from "../../../utils/batchEmployeeImport";

const TABLE_PROPS = {
  search: true,
  searchLabel: "Search",
  pageSize: 10,
  scrollClassName: "",
  emptyMessage: "No payroll records found",
  loadingMessage: "Loading...",
};

const SALARY_ADVANCE_STEPS = [
  { id: 1, title: "Upload & Validate", desc: "Upload employee salary advance sheet" },
  { id: 2, title: "Create Weekly Period", desc: "Generate dedicated weekly payroll period" },
  { id: 3, title: "Create Batch & Assign", desc: "Create SAL-ADV batch and link employees" },
  { id: 4, title: "Process Advance", desc: "Execute salary advance calculation" },
];

const PayrollProcessing = () => {
  const dispatch = useDispatch();

  // Mode: "PAYROLL" | "SALARY_ADVANCE"
  const [activeMode, setActiveMode] = useState("PAYROLL");

  // -------------------------------------------------------------
  // Standard Payroll State
  // -------------------------------------------------------------
  const [running, setRunning] = useState(false);
  const [selectedPeriod, setSelectedPeriod] = useState("");
  const [selectedBatch, setSelectedBatch] = useState("");
  const [preview, setPreview] = useState([]);
  const [previewLoading, setPreviewLoading] = useState(false);

  const [breakdownOpen, setBreakdownOpen] = useState(false);
  const [selectedPayroll, setSelectedPayroll] = useState(null);

  const [batchEmployees, setBatchEmployees] = useState([]);
  const [batchEmployeesLoading, setBatchEmployeesLoading] = useState(false);

  const [approvalDialogOpen, setApprovalDialogOpen] = useState(false);
  const [approvalStatus, setApprovalStatus] = useState(APPROVAL_STATUS.IDLE);
  const [approvalError, setApprovalError] = useState('');

  // -------------------------------------------------------------
  // Salary Advance State
  // -------------------------------------------------------------
  const [advFileName, setAdvFileName] = useState("");
  const [advRows, setAdvRows] = useState([]);
  const [advParseError, setAdvParseError] = useState(null);
  const [advProcessing, setAdvProcessing] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [advLogs, setAdvLogs] = useState([]);
  const [advSuccessResult, setAdvSuccessResult] = useState(null);

  // Entities & Master Data
  const { list: periods } = usePayrollEntity("payrollPeriods");
  const { list: batches } = usePayrollEntity("batchManagement");
  const { list: components } = usePayrollEntity("payrollComponents");
  const employees = useSelector((state) => state.employees?.employees || []);

  const { toast, showToast, hideToast } = useToast();

  useEffect(() => {
    dispatch(fetchAllEmployees());
  }, [dispatch]);

  // Fast-lookup map for Master Employees
  const employeeMap = useMemo(() => {
    const map = {};
    employees.forEach((emp) => {
      const sno = (emp.HED_SERVICE_NO || emp.serviceNo || '').toLowerCase();
      if (sno) map[sno] = emp;
    });
    return map;
  }, [employees]);

  // -------------------------------------------------------------
  // Payroll Mode Handlers & Effects
  // -------------------------------------------------------------
  useEffect(() => {
    if (!selectedBatch) {
      setBatchEmployees([]);
      return;
    }

    let cancelled = false;
    setBatchEmployeesLoading(true);

    dispatch(getPayrollBatchEmployees(selectedBatch))
      .then((list) => {
        if (!cancelled) setBatchEmployees(list || []);
      })
      .catch((error) => {
        console.error("Failed to load batch employees:", error);
        if (!cancelled) setBatchEmployees([]);
      })
      .finally(() => {
        if (!cancelled) setBatchEmployeesLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [selectedBatch, dispatch]);

  useEffect(() => {
    if (!selectedPeriod || activeMode !== "PAYROLL") {
      setPreview([]);
      return;
    }

    const loadPreview = async () => {
      setPreviewLoading(true);
      try {
        const result = await dispatch(
          getPayrollPreview(selectedPeriod, batchEmployees)
        );
        setPreview(result || []);
        if (!result || result.length === 0) {
          showToast("The selected payroll period has already been generated or has no employees.", 'warning');
        }
      } catch (error) {
        console.error("Payroll preview error:", error);
        setPreview([]);
        showToast(error?.message || "Failed to load payroll preview.", 'error');
      } finally {
        setPreviewLoading(false);
      }
    };

    loadPreview();
  }, [selectedPeriod, batchEmployees, dispatch, activeMode]);

  const totalGross = preview.reduce((sum, row) => sum + Number(row.gross || 0), 0);
  const totalNet = preview.reduce((sum, row) => sum + Number(row.net || 0), 0);

  const handlePeriodChange = (value) => {
    setSelectedPeriod(value);
    setSelectedBatch("");
    setPreview([]);
  };

  const handleOpenApprovalDialog = () => {
    if (!selectedPeriod) {
      showToast("Please select a payroll period.", "warning");
      return;
    }
    if (preview.length === 0) {
      showToast("There are no payroll records available for approval.", "warning");
      return;
    }
    setApprovalStatus(APPROVAL_STATUS.IDLE);
    setApprovalError('');
    setApprovalDialogOpen(true);
  };

  const handleExecuteSubmission = async () => {
    setRunning(true);
    try {
      setApprovalStatus(APPROVAL_STATUS.GENERATING_PAYROLL);
      await dispatch(calculatePayroll(selectedPeriod, getLoggedInServiceNo()));

      setApprovalStatus(APPROVAL_STATUS.GENERATING_BANK_REPORT);
      const bankResponse = await payRollService.GetBankReportDetailsByPeriodId(selectedPeriod);

      if (bankResponse && bankResponse.StatusCode !== 200) {
        throw new Error(bankResponse.Result || "Failed to generate bank report.");
      }

      setApprovalStatus(APPROVAL_STATUS.COMPLETED);
      setPreview([]);
      setSelectedPeriod("");
      setSelectedBatch("");
      setBatchEmployees([]);
    } catch (error) {
      console.error("[Payroll Processing] Submission workflow failed: ", error);
      const msg =
        error?.response?.data?.message ||
        error?.response?.data?.Message ||
        error?.message ||
        "Failed to complete payroll submission.";
      setApprovalError(msg);
      setApprovalStatus(APPROVAL_STATUS.FAILED);
    } finally {
      setRunning(false);
    }
  };

  const handleRefreshPreview = async () => {
    if (!selectedPeriod) {
      showToast("Please select a payroll period.", "warning");
      return;
    }
    setPreviewLoading(true);
    try {
      const result = await dispatch(getPayrollPreview(selectedPeriod, batchEmployees));
      setPreview(result || []);
      showToast("Payroll preview refreshed.", "success");
    } catch (error) {
      console.error("Payroll preview error:", error);
      showToast(error?.message || "Failed to refresh payroll preview.", "error");
    } finally {
      setPreviewLoading(false);
    }
  };

  const handleDownloadExcel = async () => {
    if (!preview || preview.length === 0) return;

    const detailedPreviewList = await Promise.all(
      preview.map(async (row) => {
        try {
          const response = await payRollService.GetPreviewPayroll(selectedPeriod, row.employeeId);
          return response?.data?.ResultSet || null;
        } catch {
          return null;
        }
      })
    );

    const validDetails = detailedPreviewList.filter(Boolean);
    const earningCompNames = new Set();
    const deductionCompNames = new Set();

    validDetails.forEach((res) => {
      res.Details?.forEach((d) => {
        const name = d.COMPONENT_NAME;
        if (!name) return;
        const code = String(d.COMPONENT_CODE || '').toUpperCase();
        if (code === 'BASIC' || code === 'BASIC-SAL' || code === 'EPF-EE') return;
        if (d.COMPONENT_TYPE === 'E') earningCompNames.add(name);
        else if (d.COMPONENT_TYPE === 'D') deductionCompNames.add(name);
      });
    });

    const dynamicEarnings = Array.from(earningCompNames);
    const dynamicDeductions = Array.from(deductionCompNames);

    const headers = [
      'No', 'Payroll No', 'Pay Date', 'Service No', 'Employee Name',
      'Working Days', 'Present Days', 'No-Pay Days', 'OT Hours',
      'Gross Earnings (Rs)', 'Total Earnings to Gross (Rs)', 'Total Deductions from Gross (Rs)',
      'Employee EPF 8% (Rs)',
      ...dynamicEarnings.map((name) => `${name} (Rs)`),
      ...dynamicDeductions.map((name) => `${name} (Rs)`),
      'Employer EPF 12% (Rs)', 'Employer ETF 3% (Rs)', 'Net Salary (Rs)',
    ];

    const workbook = new ExcelJS.Workbook();
    const periodObj = periods.find((p) => String(p.id) === String(selectedPeriod));
    const periodName = periodObj?.name || 'Payroll_Preview';
    const worksheet = workbook.addWorksheet('Payroll Preview');

    const headerRow = worksheet.addRow(headers);
    headerRow.height = 24;
    headerRow.eachCell((cell) => {
      cell.font = { name: 'Calibri', size: 10, bold: true, color: { argb: 'FF9A3412' } };
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFF7ED' } };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
      cell.border = {
        top: { style: 'thin', color: { argb: 'FF000000' } },
        bottom: { style: 'thin', color: { argb: 'FF000000' } },
        left: { style: 'thin', color: { argb: 'FF000000' } },
        right: { style: 'thin', color: { argb: 'FF000000' } },
      };
    });

    const borderBlack = {
      top: { style: 'thin', color: { argb: 'FF000000' } },
      bottom: { style: 'thin', color: { argb: 'FF000000' } },
      left: { style: 'thin', color: { argb: 'FF000000' } },
      right: { style: 'thin', color: { argb: 'FF000000' } },
    };

    preview.forEach((row, index) => {
      const detailObj = validDetails.find((d) => String(d.Summary?.[0]?.EMPLOYEE_ID) === String(row.employeeId));
      const summary = detailObj?.Summary?.[0] || {};
      const componentDetails = detailObj?.Details || [];

      const compMap = {};
      componentDetails.forEach((d) => {
        compMap[d.COMPONENT_NAME] = Number(d.AMOUNT || 0);
      });

      const rowValues = [
        index + 1,
        summary.PAYROLL_NO || '-',
        summary.PAY_DATE ? String(summary.PAY_DATE).split(' ')[0] : '-',
        row.empNo,
        row.name,
        Number(summary.WORKING_DAYS ?? row.workingDays ?? 0),
        Number(summary.PRESENT_DAYS ?? row.presentDays ?? 0),
        Number(summary.NO_PAY_DAYS ?? row.noPayDays ?? 0),
        Number(summary.OT_HOURS ?? row.otHours ?? 0),
        Number(summary.TOTAL_EARNINGS ?? row.gross ?? 0),
        Number(summary.TOTAL_EARNINGS ?? row.totalEarnings ?? 0),
        Number(summary.TOTAL_DEDUCTIONS ?? row.totalDeductions ?? 0),
        Number(summary.EMPLOYEE_EPF ?? row.epf ?? 0),
        ...dynamicEarnings.map((name) => (compMap[name] !== undefined ? compMap[name] : "-")),
        ...dynamicDeductions.map((name) => (compMap[name] !== undefined ? compMap[name] : "-")),
        Number(summary.EMPLOYER_EPF ?? row.employerEpf ?? 0),
        Number(summary.EMPLOYER_ETF ?? row.employerEtf ?? 0),
        Number(summary.NET_SALARY ?? row.net ?? 0),
      ];

      const addedRow = worksheet.addRow(rowValues);
      addedRow.height = 20;

      addedRow.eachCell((cell, colNumber) => {
        const colIdx = colNumber - 1;
        const isCurrency = colIdx >= 9;
        const isCenter = (colIdx >= 5 && colIdx <= 8) || colIdx === 0 || colIdx === 2;

        cell.font = { name: 'Calibri', size: 10, color: { argb: 'FF374151' } };
        cell.border = borderBlack;

        if (cell.value === "-") {
          cell.alignment = { vertical: 'middle', horizontal: 'center' };
        } else if (isCurrency) {
          cell.alignment = { vertical: 'middle', horizontal: 'right' };
          cell.numFmt = '#,##0.00';
        } else if (isCenter) {
          cell.alignment = { vertical: 'middle', horizontal: 'center' };
        } else {
          cell.alignment = { vertical: 'middle', horizontal: 'left' };
        }
      });
    });

    worksheet.columns.forEach((col) => {
      let maxLen = 0;
      col.eachCell({ includeEmpty: false }, (cell) => {
        const str = cell.value ? cell.value.toString() : '';
        if (str.length > maxLen) maxLen = str.length;
      });
      col.width = Math.max(maxLen + 3, 11);
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(blob, `${periodName.replace(/[^a-zA-Z0-9_-]/g, '_')}_Preview_Summary.xlsx`);
  };

  // -------------------------------------------------------------
  // Salary Advance Handlers & Validation
  // -------------------------------------------------------------
  const resetSalaryAdvance = () => {
    setAdvFileName("");
    setAdvRows([]);
    setAdvParseError(null);
    setCurrentStep(1);
    setAdvLogs([]);
    setAdvSuccessResult(null);
  };

  const handleAdvFile = async (file) => {
    if (!file) return;
    setAdvParseError(null);
    setAdvFileName(file.name);
    setAdvSuccessResult(null);

    try {
      const parsed = await readBatchWorkbook(file);
      if (!parsed.length) {
        setAdvParseError("No data rows found in the uploaded file.");
        return;
      }

      const countMap = {};
      parsed.forEach((r) => {
        const key = String(r.empNo || "").trim().toLowerCase();
        if (key) countMap[key] = (countMap[key] || 0) + 1;
      });

      const duplicateInFileSet = new Set(
        Object.keys(countMap).filter((k) => countMap[k] > 1)
      );

      const validated = parsed.map((r) => {
        const { values, errors } = validateBatchRow(r, employeeMap, new Set(), duplicateInFileSet);
        const emp = employeeMap[values.empNo?.toLowerCase()];
        return {
          _row: r._row,
          values,
          errors,
          employeeName: emp?.HED_REPORT_NAME || (emp ? `${emp.HED_FIRST_NAME || ''} ${emp.HED_LAST_NAME || ''}`.trim() : 'Unknown'),
          employeeId: emp?.HED_EMPLOYEE_ID,
        };
      });

      setAdvRows(validated);
    } catch (err) {
      setAdvParseError(err?.message || "Failed to parse excel file.");
    }
  };

  const validAdvRows = useMemo(() => advRows.filter((r) => r.errors.length === 0), [advRows]);
  const invalidAdvRows = useMemo(() => advRows.filter((r) => r.errors.length > 0), [advRows]);
  const totalAdvAmount = useMemo(() => validAdvRows.reduce((sum, r) => sum + (Number(r.values.amount) || 0), 0), [validAdvRows]);

  const addAdvLog = (msg) => {
    setAdvLogs((prev) => [...prev, `${new Date().toLocaleTimeString()} - ${msg}`]);
  };

  // Generate Suggested Batch Number
  const getNextBatchNo = () => {
    const max = batches.reduce((highest, batch) => {
      const match = /^BATCH(\d+)$/i.exec(batch.batchNo || '');
      if (!match) return highest;
      return Math.max(highest, Number(match[1]));
    }, 0);
    return `BATCH${String(max + 1).padStart(3, '0')}`;
  };

  // Main Salary Advance Orchestration Pipeline
  const handleProcessSalaryAdvance = async () => {
    if (!validAdvRows.length) {
      showToast("There are no valid employee records to process.", "warning");
      return;
    }

    setAdvProcessing(true);
    setAdvLogs([]);

    const now = new Date();
    const yyyy = now.getFullYear();
    const mm = String(now.getMonth() + 1).padStart(2, "0");
    const dd = String(now.getDate()).padStart(2, "0");
    const todayIso = `${yyyy}-${mm}-${dd}`;
    const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const currentMonthName = monthNames[now.getMonth()];

    try {
      // -------------------------------------------------------------
      // Step 2: Create WEEKLY Payroll Period for Today
      // -------------------------------------------------------------
      setCurrentStep(2);
      addAdvLog(`Creating weekly payroll period for ${todayIso}...`);

      const periodName = `${yyyy} ${currentMonthName} Sal Adv`;
      const periodCode = `ADV-${yyyy}${mm}${dd}-${Math.floor(100 + Math.random() * 900)}`;

      await payRollService.AddPayRollPeriod({
        periodCode,
        periodName,
        year: yyyy,
        month: now.getMonth() + 1,
        payFrequency: "W",
        payrollStartDate: todayIso,
        payrollEndDate: todayIso,
        attendanceStartDate: todayIso,
        attendanceEndDate: todayIso,
        otStartDate: todayIso,
        otEndDate: todayIso,
        paymentDate: todayIso,
        status: "A",
        isLocked: 0,
        glPosted: 0,
        bankTransferGenerated: 0,
        createdBy: getLoggedInServiceNo() || "system",
        isActive: 1,
        remarks: "Auto-generated weekly period for Salary Advance",
      });

      addAdvLog(`Payroll period "${periodName}" created successfully.`);

      // Refresh and fetch the newly created period ID
      const periodRes = await payRollService.GetPayRollPeriodList();
      const updatedPeriods = periodRes?.data?.ResultSet || [];
      const createdPeriodObj = updatedPeriods.find((p) => p.HPP_PERIOD_CODE === periodCode) || updatedPeriods[updatedPeriods.length - 1];
      const newPeriodId = createdPeriodObj?.HPP_PAYROLL_PERIOD_ID;

      if (!newPeriodId) {
        throw new Error("Could not retrieve created payroll period ID.");
      }
      addAdvLog(`Identified Period ID: ${newPeriodId}`);

      // -------------------------------------------------------------
      // Step 3: Create Batch for SAL-ADV and Assign Employees
      // -------------------------------------------------------------
      setCurrentStep(3);
      addAdvLog("Creating batch for SAL-ADV component...");

      // Find SAL-ADV Component
      const salAdvComp = components.find(
        (c) => String(c.code).toUpperCase() === "SAL-ADV" || c.name?.toLowerCase().includes("salary advance")
      );
      const componentId = salAdvComp?.id || 3016; // Fallback to component ID 3016

      const batchNo = getNextBatchNo();
      const batchName = `${periodName} Batch`;

      await payRollService.AddPayRollBatch({
        batchId: 0,
        batchNo,
        batchName,
        payrollPeriodId: newPeriodId,
        componentId: componentId,
        calculationMethod: "F",
        amount: 0,
        percentage: 0,
        effectiveDate: todayIso,
        description: `Batch for ${periodName}`,
        status: "A",
        approvedBy: getLoggedInServiceNo() || "system",
        createdBy: getLoggedInServiceNo() || "system",
        isActive: 1,
        remarks: "Auto-generated for Salary Advance",
      });

      // Find the created batch ID
      const batchRes = await payRollService.GetPayRollBatchList();
      const updatedBatches = batchRes?.data?.ResultSet || [];
      const createdBatchObj = updatedBatches.find((b) => b.HPB_BATCH_NO === batchNo) || updatedBatches[updatedBatches.length - 1];
      const newBatchId = createdBatchObj?.HPB_BATCH_ID;

      if (!newBatchId) {
        throw new Error("Could not retrieve created Batch ID.");
      }
      addAdvLog(`Batch "${batchNo}" created with ID: ${newBatchId}`);

      // Add employees to the batch
      addAdvLog(`Assigning ${validAdvRows.length} employees to the batch...`);
      for (const row of validAdvRows) {
        await PayrollBatchEmployeeService.AddPayRollEmp({
          batchId: newBatchId,
          employeeId: row.employeeId,
          amount: row.values.amount,
          percentage: null,
          isIncluded: 1,
          isProcessed: 0,
          isActive: 1,
          overrideReason: "Salary Advance Import",
          remarks: "Salary Advance Upload",
          createdBy: getLoggedInServiceNo() || "system",
        });
      }
      addAdvLog(`Successfully assigned ${validAdvRows.length} employees.`);

      // -------------------------------------------------------------
      // Step 4: Execute Salary Advance Calculation
      // -------------------------------------------------------------
      setCurrentStep(4);
      addAdvLog(`Calling CalSalADVPayRoll API for period ID ${newPeriodId}...`);

      const advResponse = await payRollService.CalculateSalaryAdvancePayroll(
        newPeriodId,
        getLoggedInServiceNo() || "system"
      );

      const resStatus = advResponse?.data?.StatusCode ?? advResponse?.StatusCode;
      if (resStatus && Number(resStatus) !== 200) {
        throw new Error(advResponse?.data?.Result || advResponse?.Result || "Salary advance processing failed.");
      }

      addAdvLog("Salary Advance processed successfully by backend.");
      setAdvSuccessResult({
        periodId: newPeriodId,
        periodName,
        batchNo,
        count: validAdvRows.length,
        totalAmount: totalAdvAmount,
      });

      showToast(`Salary advance successfully processed for ${validAdvRows.length} employees!`, "success");
      dispatch(fetchPayrollEntityList("payrollPeriods"));
      dispatch(fetchPayrollEntityList("batchManagement"));
    } catch (error) {
      console.error("[Salary Advance] Process failed:", error);
      const msg = error?.response?.data?.Message || error?.message || "Failed to process salary advance.";
      addAdvLog(`Error: ${msg}`);
      showToast(msg, "error");
    } finally {
      setAdvProcessing(false);
    }
  };

  return (
    <div className="space-y-4 p-6">
      {/* ─────────────────────────────────────────────────────────────
          Header with Mode Switcher
      ───────────────────────────────────────────────────────────── */}
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <Breadcrumb
          trail={["Payroll", activeMode === "PAYROLL" ? "Payroll Processing" : "Salary Advance"]}
          title={activeMode === "PAYROLL" ? "Payroll Processing" : "Salary Advance Processing"}
          subtitle={
            activeMode === "PAYROLL"
              ? "Generate payroll and review the final payroll results before approval."
              : "Upload and calculate weekly salary advances before standard monthly payroll runs."
          }
        />

        {/* Mode Toggle Switcher */}
        <div className="inline-flex overflow-hidden rounded-lg border border-gray-300 bg-white">
          <button
            type="button"
            disabled={advProcessing || running}
            onClick={() => setActiveMode("PAYROLL")}
            className={`flex items-center gap-2 border-r px-4 py-2.5 text-xs font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-50 ${
              activeMode === "PAYROLL"
                ? "bg-orange-50 text-orange-700 ring-1 ring-inset ring-orange-400 rounded-l-lg"
                : "border-gray-300 text-gray-500 hover:bg-gray-50 hover:text-gray-800"
            }`}
          >
            <CalendarDays size={15} />
            Regular Payroll
          </button>

          <button
            type="button"
            disabled={advProcessing || running}
            onClick={() => setActiveMode("SALARY_ADVANCE")}
            className={`flex items-center gap-2 px-4 py-2.5 text-xs font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-50 ${
              activeMode === "SALARY_ADVANCE"
                ? "bg-orange-50 text-orange-700 ring-1 ring-inset ring-orange-400 rounded-r-lg"
                : "text-gray-500 hover:bg-gray-50 hover:text-gray-800"
            }`}
          >
            <Coins size={15} />
            Salary Advance
          </button>
        </div>
      </div>

      {/* ─────────────────────────────────────────────────────────────
          SALARY ADVANCE MODE VIEW
      ───────────────────────────────────────────────────────────── */}
      {activeMode === "SALARY_ADVANCE" ? (
        <div className="space-y-5">
          {/* Visual Stepper */}
          <div className="rounded-xl border border-gray-200 bg-white p-5 shadow-sm">
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-4">
              {SALARY_ADVANCE_STEPS.map((step) => {
                const isCompleted = currentStep > step.id || Boolean(advSuccessResult);
                const isCurrent = currentStep === step.id && !advSuccessResult;

                return (
                  <div key={step.id} className="relative flex items-center sm:block">
                    <div className="flex items-center gap-3">
                      <div
                        className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xs font-semibold transition-colors ${
                          isCompleted
                            ? "bg-emerald-600 text-white"
                            : isCurrent
                            ? "bg-amber-600 text-white ring-4 ring-amber-100"
                            : "bg-gray-100 text-gray-500"
                        }`}
                      >
                        {isCompleted ? <Check size={14} /> : step.id}
                      </div>

                      <div className="min-w-0 flex-1">
                        <p
                          className={`text-xs font-medium truncate ${
                            isCurrent ? "font-semibold text-gray-900" : "text-gray-600"
                          }`}
                        >
                          {step.title}
                        </p>
                        <p className="text-[11px] text-gray-400 truncate">{step.desc}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Action / Upload Card */}
          <div className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
            <div className="flex flex-col gap-4 border-b border-gray-200 px-5 py-4 sm:flex-row sm:items-center sm:justify-between">
              <div>
                <h3 className="text-sm font-semibold text-gray-900">
                  Import Salary Advance Spreadsheet
                </h3>
                <p className="mt-0.5 text-xs text-gray-500">
                  Upload an Excel file with Employee Service Number and Advance Amount.
                </p>
              </div>

              <div className="flex flex-wrap items-center gap-2">
                <button
                  type="button"
                  onClick={() => downloadBatchEmployeeTemplate({ batchNo: "Salary_Advance", amount: 5000 })}
                  className="inline-flex h-9 items-center gap-1.5 rounded-lg border border-gray-300 bg-white px-3 text-xs font-medium text-gray-700 hover:bg-gray-50"
                >
                  <Download size={14} /> Download Template
                </button>

                <label className={`inline-flex h-9 items-center gap-1.5 rounded-lg bg-amber-600 px-4 text-xs font-semibold text-white hover:bg-amber-700 cursor-pointer shadow-xs ${advProcessing ? 'opacity-50 cursor-not-allowed' : ''}`}>
                  <Upload size={14} />
                  <span>Choose File</span>
                  <input
                    type="file"
                    accept=".xlsx,.xls"
                    className="hidden"
                    disabled={advProcessing}
                    onChange={(e) => {
                      handleAdvFile(e.target.files?.[0]);
                      e.target.value = "";
                    }}
                  />
                </label>
              </div>
            </div>

            {/* Parse Error Notification */}
            {advParseError && (
              <div className="mx-5 my-4 flex items-center gap-2 rounded-lg border border-red-200 bg-red-50 p-3 text-xs text-red-700">
                <AlertCircle size={15} className="shrink-0" />
                <span>{advParseError}</span>
              </div>
            )}

            {/* Validation / Summary Bar */}
            {advRows.length > 0 && (
              <div className="flex flex-wrap items-center justify-between border-b border-gray-100 bg-gray-50 px-5 py-3">
                <div className="flex items-center gap-3">
                  <span className="text-xs text-gray-600">
                    File: <strong className="text-gray-900">{advFileName}</strong>
                  </span>
                  <span className="inline-flex items-center gap-1 rounded-full bg-emerald-50 px-2.5 py-0.5 text-xs font-medium text-emerald-700">
                    <CheckCircle2 size={12} /> {validAdvRows.length} Valid
                  </span>
                  {invalidAdvRows.length > 0 && (
                    <span className="inline-flex items-center gap-1 rounded-full bg-red-50 px-2.5 py-0.5 text-xs font-medium text-red-700">
                      <AlertCircle size={12} /> {invalidAdvRows.length} Invalid
                    </span>
                  )}
                </div>

                <div className="text-right">
                  <span className="text-xs text-gray-500">Total Advance: </span>
                  <strong className="text-sm font-semibold text-gray-900">{fmtMoney(totalAdvAmount)}</strong>
                </div>
              </div>
            )}

            {/* Table or Empty Placeholder */}
            {advRows.length === 0 ? (
              <div className="px-5 py-12 text-center">
                <div className="mx-auto mb-3 flex h-11 w-11 items-center justify-center rounded-full bg-amber-50 text-amber-600">
                  <FileSpreadsheet size={22} />
                </div>
                <p className="text-sm font-medium text-gray-800">No Salary Advance File Selected</p>
                <p className="mt-1 text-xs text-gray-500">
                  Please upload an Excel file containing Service Numbers and Advance Amounts to start.
                </p>
              </div>
            ) : (
              <div>
                <Table
                  {...TABLE_PROPS}
                  rows={advRows}
                  rowKey="_row"
                  searchKeys={["values.empNo", "employeeName"]}
                  searchPlaceholder="Search employees in preview..."
                  columns={[
                    {
                      key: "_row",
                      label: "#",
                      align: "center",
                      render: (r) => <span className="text-gray-400">{r._row}</span>,
                    },
                    {
                      key: "empNo",
                      label: "Service No",
                      className: "font-semibold text-gray-900",
                      render: (r) => r.values?.empNo,
                    },
                    {
                      key: "employeeName",
                      label: "Employee Name",
                      grow: true,
                      className: "text-gray-700",
                      render: (r) => r.employeeName,
                    },
                    {
                      key: "amount",
                      label: "Amount (Rs)",
                      align: "right",
                      className: "font-semibold text-gray-900 tabular-nums",
                      render: (r) => (r.values?.amount !== undefined ? fmtMoney(r.values.amount) : "—"),
                    },
                    {
                      key: "status",
                      label: "Validation Status",
                      align: "center",
                      render: (r) =>
                        r.errors.length === 0 ? (
                          <span className="inline-flex items-center gap-1 rounded bg-emerald-50 px-2 py-0.5 text-[11px] font-semibold text-emerald-700">
                            <CheckCircle2 size={12} /> Ready
                          </span>
                        ) : (
                          <div className="text-left text-[11px] text-red-600">
                            {r.errors.map((e, idx) => (
                              <div key={idx}>• {e}</div>
                            ))}
                          </div>
                        ),
                    },
                  ]}
                />

                {/* Footer Process Button */}
                <div className="flex flex-col gap-3 border-t border-gray-200 px-5 py-4 sm:flex-row sm:items-center sm:justify-between bg-gray-50/50">
                  <button
                    type="button"
                    onClick={resetSalaryAdvance}
                    disabled={advProcessing}
                    className="h-10 rounded-lg border border-gray-300 bg-white px-4 text-xs font-medium text-gray-600 hover:bg-gray-50 disabled:opacity-50"
                  >
                    Reset & Upload New
                  </button>

                  <button
                    type="button"
                    onClick={handleProcessSalaryAdvance}
                    disabled={advProcessing || validAdvRows.length === 0}
                    className="inline-flex h-10 items-center justify-center gap-2 rounded-lg bg-amber-600 px-6 text-xs font-semibold text-white shadow-sm hover:bg-amber-700 disabled:bg-gray-300 disabled:text-gray-500 disabled:cursor-not-allowed"
                  >
                    {advProcessing ? (
                      <>
                        <Loader2 size={15} className="animate-spin" />
                        Processing Salary Advance...
                      </>
                    ) : (
                      <>
                        <Coins size={15} />
                        Process Salary Advance ({validAdvRows.length} Employees)
                      </>
                    )}
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* Real-time Processing Logs / Progress Box */}
          {/* {(advProcessing || advLogs.length > 0) && (
            <div className="rounded-xl border border-gray-200 bg-white p-5 shadow-sm space-y-3">
              <h4 className="text-xs font-semibold uppercase tracking-wider text-gray-500">
                Execution Log
              </h4>
              <div className="max-h-44 overflow-y-auto rounded-lg bg-gray-900 p-3 font-mono text-xs text-gray-200 space-y-1">
                {advLogs.map((log, index) => (
                  <div key={index}>{log}</div>
                ))}
              </div>
            </div>
          )} */}

          {/* Success Banner */}
          {advSuccessResult && (
            <div className="rounded-xl border border-emerald-200 bg-emerald-50 p-4 text-emerald-900 flex items-start gap-3">
              <CheckCircle2 size={18} className="text-emerald-600 shrink-0 mt-0.5" />
              <div>
                <h4 className="text-sm font-semibold">Salary Advance Processing Complete</h4>
                <p className="mt-0.5 text-xs text-emerald-700">
                  Successfully processed for <strong>{advSuccessResult.count}</strong> employees under period{" "}
                  <strong>{advSuccessResult.periodName}</strong>. Total payout amount:{" "}
                  <strong>{fmtMoney(advSuccessResult.totalAmount)}</strong>.
                </p>
              </div>
            </div>
          )}
        </div>
      ) : (
        /* ─────────────────────────────────────────────────────────────
            REGULAR PAYROLL MODE VIEW (Original Component View)
        ───────────────────────────────────────────────────────────── */
        <>
          {/* Payroll Generation Header & Controls */}
          <div className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
            <div className="px-5 py-4">
              <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
                <div className="flex items-center gap-3">
                  <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary-50 text-primary-700">
                    <CalendarDays size={18} />
                  </div>
                  <div>
                    <h2 className="text-sm font-semibold text-gray-900">Generate Payroll</h2>
                    <p className="mt-0.5 text-xs text-gray-500">
                      Select a payroll period and generate the payroll calculation.
                    </p>
                  </div>
                </div>

                <div className="flex flex-col gap-3 sm:flex-row sm:items-end">
                  <div className="w-full sm:w-[280px]">
                    <label htmlFor="payroll-period" className="mb-1.5 block text-xs font-medium text-gray-700">
                      Payroll Period <span className="ml-1 text-red-500">*</span>
                    </label>
                    <SearchableSelect
                      id="payroll-period"
                      value={selectedPeriod}
                      onChange={handlePeriodChange}
                      options={periods
                        .filter((period) => period.status === "Active")
                        .map((period) => ({ value: period.id, label: `${period.code} ${period.name}` }))}
                      emptyOption={{ value: "", label: "Select Payroll Period" }}
                      placeholder="Select Payroll Period"
                      searchPlaceholder="Search payroll period..."
                      className="h-10 w-full rounded-md border border-gray-300 bg-white px-3 text-sm text-gray-700 outline-none transition focus:border-primary-600 focus:ring-1 focus:ring-primary-600"
                    />
                  </div>

                  <button
                    type="button"
                    onClick={handleRefreshPreview}
                    disabled={!selectedPeriod || previewLoading || running}
                    className="inline-flex h-10 shrink-0 items-center justify-center gap-2 rounded-md border border-gray-300 bg-white px-4 text-sm font-medium text-gray-600 transition-colors hover:border-primary-600 hover:bg-primary-50 hover:text-primary-700 disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-400"
                  >
                    <RefreshCw size={15} className={previewLoading ? "animate-spin" : ""} />
                    Refresh Preview
                  </button>

                  {preview.length > 0 && (
                    <button
                      type="button"
                      onClick={handleDownloadExcel}
                      disabled={previewLoading || running}
                      className="inline-flex h-10 shrink-0 items-center justify-center gap-2 rounded-md bg-amber-600 px-4 text-sm font-medium text-white shadow-xs transition-colors hover:bg-amber-700 disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-500"
                    >
                      <Download size={15} />
                      Export to Excel
                    </button>
                  )}
                </div>
              </div>

              {selectedBatch && (
                <p className="mt-3 text-xs text-gray-500">
                  {batchEmployeesLoading
                    ? "Loading batch employees..."
                    : `${batchEmployees.length} active employee(s) in this batch.`}
                </p>
              )}
            </div>
          </div>

          {/* Payroll Preview Table */}
          <div className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
            <div className="flex flex-col gap-3 border-b border-gray-200 px-5 py-4 sm:flex-row sm:items-center sm:justify-between">
              <div>
                <h2 className="text-sm font-semibold text-gray-900">Payroll Preview</h2>
                <p className="mt-0.5 text-xs text-gray-500">
                  Review calculated payroll amounts before submitting the run for approval.
                </p>
              </div>

              {preview.length > 0 && (
                <div className="flex flex-wrap items-center gap-5 text-right">
                  <div>
                    <p className="text-[11px] uppercase tracking-wide text-gray-400">Employees</p>
                    <p className="text-sm font-semibold text-gray-900">{preview.length}</p>
                  </div>
                  <div>
                    <p className="text-[11px] uppercase tracking-wide text-gray-400">Gross</p>
                    <p className="text-sm font-semibold text-gray-900">{fmtMoney(totalGross)}</p>
                  </div>
                  <div>
                    <p className="text-[11px] uppercase tracking-wide text-gray-400">Net Pay</p>
                    <p className="text-sm font-semibold text-primary-700">{fmtMoney(totalNet)}</p>
                  </div>
                </div>
              )}
            </div>

            {!selectedPeriod ? (
              <div className="px-5 py-12 text-center">
                <div className="mx-auto mb-3 flex h-10 w-10 items-center justify-center rounded-full bg-gray-100 text-gray-400">
                  <CalendarDays size={19} />
                </div>
                <p className="text-sm font-medium text-gray-700">Select a payroll period</p>
                <p className="mt-1 text-xs text-gray-500">
                  Choose a payroll period above to generate and preview payroll.
                </p>
              </div>
            ) : (
              <>
                <Table
                  {...TABLE_PROPS}
                  loading={previewLoading}
                  rows={preview}
                  rowKey={(row) => row.empNo || row.serviceNo || row.id}
                  searchKeys={["empNo", "name"]}
                  searchPlaceholder="Search employees..."
                  columns={[
                    {
                      key: "name",
                      label: "Employee",
                      grow: true,
                      className: "font-semibold text-gray-900",
                      render: (r) => `${r.name} (${r.empNo})`,
                    },
                    {
                      key: "workingDays",
                      label: "Working Days",
                      align: "right",
                      className: "text-gray-600 tabular-nums",
                      render: (r) => r.workingDays,
                    },
                    {
                      key: "presentDays",
                      label: "Present",
                      align: "right",
                      className: "text-gray-600 tabular-nums",
                      render: (r) => r.presentDays,
                    },
                    {
                      key: "gross",
                      label: "Gross (Rs)",
                      align: "right",
                      className: "font-semibold text-gray-900 tabular-nums",
                      render: (r) => fmtMoney(r.gross),
                    },
                    {
                      key: "totalDeductions",
                      label: "Deductions (Rs)",
                      align: "right",
                      className: "text-gray-600 tabular-nums",
                      render: (r) => fmtMoney(r.totalDeductions),
                    },
                    {
                      key: "epf",
                      label: "EPF (Rs)",
                      align: "right",
                      className: "text-gray-600 tabular-nums",
                      render: (r) => fmtMoney(r.epf),
                    },
                    {
                      key: "net",
                      label: "Net Pay (Rs)",
                      align: "right",
                      className: "font-semibold text-gray-900 tabular-nums",
                      render: (r) => fmtMoney(r.net),
                    },
                    {
                      key: "breakdown",
                      label: "Breakdown",
                      align: "center",
                      render: (r) => (
                        <button
                          type="button"
                          onClick={() => {
                            setSelectedPayroll(r);
                            setBreakdownOpen(true);
                          }}
                          className="inline-flex h-8 items-center gap-1.5 rounded-md border border-gray-200 px-2.5 text-xs font-medium text-gray-600 transition-colors hover:border-primary-200 hover:bg-primary-50 hover:text-primary-700"
                        >
                          <Eye size={14} />
                          View
                        </button>
                      ),
                    },
                  ]}
                />

                {preview.length > 0 && (
                  <div className="flex flex-col gap-2 border-t border-gray-200 px-5 py-4 sm:flex-row sm:items-center sm:justify-end">
                    <button
                      type="button"
                      onClick={() => {
                        setPreview([]);
                        setSelectedPeriod("");
                        setSelectedBatch("");
                        setBatchEmployees([]);
                      }}
                      disabled={running}
                      className="inline-flex items-center justify-center rounded-md border border-gray-300 bg-white px-4 py-2.5 text-sm font-medium text-gray-600 transition-colors hover:border-primary-600 hover:bg-primary-50 hover:text-primary-700 disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-400"
                    >
                      Start New Run
                    </button>

                    <button
                      type="button"
                      onClick={handleOpenApprovalDialog}
                      disabled={running || previewLoading || preview.length === 0}
                      className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-600 px-4 py-2.5 text-sm font-medium text-white transition-colors hover:bg-primary-700 disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-500"
                    >
                      <Send size={15} />
                      Submit for Approval
                    </button>
                  </div>
                )}
              </>
            )}
          </div>

          <PayrollBreakdownDialog
            open={breakdownOpen}
            payroll={selectedPayroll}
            onClose={() => {
              setBreakdownOpen(false);
              setSelectedPayroll(null);
            }}
          />

          <PayrollApprovalProgressDialog
            open={approvalDialogOpen}
            status={approvalStatus}
            errorMessage={approvalError}
            onConfirm={handleExecuteSubmission}
            onClose={() => setApprovalDialogOpen(false)}
          />
        </>
      )}

      <Toast message={toast?.message} type={toast?.type} onClose={hideToast} />
    </div>
  );
};

export default PayrollProcessing;